import {
    Avatar,
    Button,
    useTheme,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControlLabel,
    Grid,
    IconButton,
    Paper,
    Radio,
    Stack,
    TextField,
    Typography,
    Box,
    ToggleButtonGroup,
    ToggleButton,
    Checkbox,
    FormHelperText,
    ClickAwayListener,
    Tooltip
} from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { Order, OrderStatus, OrderType, Product, TransactionType, transactionTypeToJSON, Validity, Broker_Variety, Broker_OrderType, MarginFromBrokerResponse, MarginFromBrokerRequest_Order, MarginFromBrokerRequest_TradingAccount, MarginFromBrokerRequest, productToJSON } from '../../proto/generated/order'
import { Position } from '../../proto/generated/position'
import { Condition } from '../../proto/generated/nexus'
import ChargesBreakdownDrawer from '../ChargesBreakdownTooltip/ChargesBreakdownDrawer'
import React, { ChangeEvent, memo, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import { selectMargins, selectPrimaryTradingAccount, selectTradingAccounts, selectUserDetails } from '../../selectors/user'
import { selectMultiPaneFullScreen } from '../../selectors/common'
import { v4 as uuid } from 'uuid'
import { placeOrModifyOrder } from '../../services/apis/orders'
import ThinArrowDownIcon from '../../assets/icons/ThinArrowDownIcon'
import AnalyticsManager from '../../analytics/AnalyticsManager'
import websocketActions from '../../actions/websocket.actions'
import { Instrument, Security, SecurityCategory_CategoryCode, Segment } from '../../proto/generated/security'
import { isMtfEligibleCashSecurity, isTradeableSecurity } from '../../util/cashInstrument'
import { LOGOS_BASE_URL, MULTIPANE_FULLSCREEN_MODE_ID } from '../../assets/constants'
import { getColorForSymbol } from '../../util/general'
import { selectOrdersHistory, selectQuickOrderData } from '../../selectors/orders'
import { selectPositions } from '../../selectors/positions'
import { Exchange, exchangeToJSON } from '../../proto/generated/common'
import { ordersInitialState, QuickTradeData, removeQuickOrderData, setQuickOrderData, updateOrderHistory } from '../../reducer/orders.reducer'
import { fetchSecuritySnapshotsBulk } from '../../services/apis/candles'
import { PlaceOrModifyOrdersRequest, TradingAccountStatus } from '../../proto/generated/trading-bridge'
import { selectReferenceSecurityMap } from '../../selectors/security'
import QuickTradeExchangeSelector from './QuickTradeExchangeSelector'
import QuickTradeSlPriceHint from './QuickTradeSlPriceHint'
import QuickTradeConditionalEntryWithLiveQuote from './QuickTradeConditionalEntryWithLiveQuote'
import {
    computeStopLossDisplayPrice,
    computeTargetDisplayPrice,
    quoteReferenceFromScalars,
    readQuickTradeQuoteScalars,
} from '../../util/quickTradeQuote'
import {
    readQuickTradePreferences,
    resolveBrokerOrderTypeForMode,
    saveQuickTradePreferencesFromOrderState,
} from '../../util/quickTradePreferences'
import { getSecurityAsync, getSecurityFromCache, getSecurityKey } from '../../util/security'
import { blue, red } from '../../assets/colors'
import { useStyles } from './styles'
import ToggleSwitch from '../common/toggleSwitch/toggleSwitch'
import useDraggable from '../../hooks/useDraggable'
import { SurveillanceWarningDialog } from './RiskDisclaimationDialog'
import { LoadingButton } from '@mui/lab'
import { PopUpPopover } from './PopUpDialog'
import AlertIcon from '../../assets/icons/AlertIcon'
import {
    addOrderAlertMessage,
    getRoundedPrice,
    isPlaceholderStrategyGroupName,
    ORDER_TYPES_STRATEGY_AUXILIARY,
    resolveBasketBatchStrategyGroupName,
} from '../../util/orders'
import TradingAccountSelector from '../tradingAccountStatus/TradingAccountSelector'
import OpenTradingAccountDialog from '../tradingAccountStatus/OpenTradingAccountDialog'
import { useTradingAccountContext } from '../../hooks/useTradingAccountContext'
import QuickTradeProductTabs from './quickTradeProductTabs/quickTradeProductTabs'
import GenericFilterTabs from '../genericTabs/genericFilterTabs'
import { SlTargetType } from '../common/slTargetInput/slTargetInput'
import { getAccountMargins, getRequiredMarginFromBroker } from '../../services/apis/tradingAccount'
import { isPaperBrokerCode } from '../../util/tradingAccounts'
import { setMarginForAccount } from '../../reducer/user.reducer'
import RefreshIcon from '../../assets/icons/RefreshIcon'
import { debounce } from 'throttle-debounce'
import { setBatchId, TradeOrder } from '../../reducer/strategyBuilder.reducer'
import OrderBookSelectionDialog from './OrderBookSelectionDialog'
import InfoIcon from '../../assets/icons/InfoIcon'
import SlTargetClearIcon from '../../assets/icons/ClearIcon'
import { useUser } from '../../context/UserContext'
import { FeatureCategory, FeatureName } from '../adminUserRestrictions/Restrictions.constants'
import {
    basketConditionalRowLabelFromStrategyGroup,
    buildStrategySpreadConditionalSnapshot,
    ConditionalEntryState,
    conditionalPrimaryUsesSpreadLhs,
    getNonAuxiliaryLegsInBatch,
    hasConditionalRuleContent,
    isConditionalEntryReady,
    orderExecutionParamsForConditionalEntry,
    quickTradeAllowsConditionalEntryRuleEditing,
    quickTradeAllowsConditionalExitRuleEditing,
    quickTradeModifySuppressesConditionalTilesOnRow,
    resolveAuxiliaryLegBatchId,
    resolveAuxiliaryLegBasketWire,
    resolveAuxiliaryLegWireIds,
    resolveBatchIdForBasketFromOrders,
    resolveBracketExitTransactionType,
    resolveConditionalAuxProduct,
} from '../../util/conditionalEntry'
import { getStrategyChartParamsFromTradeOrders } from '../../util/common'
import {
    buildQuickTradeConditionalPlacePlan,
    pickMergedConditionForOrderModify,
    pickMergedConditionForOrderModifyIgnoringExitSibling,
} from '../../util/quickTradeConditionalPlace'
import ROUTES from '../../assets/routes'
import { useNavigate } from 'react-router-dom'
import { isAdmin } from '../../util/authentication'
import { registerQuickTradePaper, syncQuickTradePaperVisibility } from './quickTradeVisibility'
import { slTargetClearBtnSx } from '../common/quickWidgets/quickTradeWidget/quickTradeFieldChrome'

type QuickTradeWindowBodyProps = {
    isVisible: boolean
}

const resolveQuickTradeSecurity = (
    security: { exchange?: number; code?: string } | undefined,
    refSecurityMap: Record<string, string>
): Security | undefined => {
    if (!security?.exchange || !security?.code) return undefined
    const key = getSecurityKey(security.exchange, security.code)
    const cached = getSecurityFromCache(key)
    if (cached) {
        if (cached.derived) {
            const refKey = refSecurityMap[key]
            return getSecurityFromCache(refKey) ?? cached
        }
        return cached
    }
    return security as Security
}

const QuickTradeWindowV2 = () => {
    const tradeData = useSelector(selectQuickOrderData) ?? ordersInitialState.quickOrder!
    const { openDialog, type } = tradeData
    const isVisible = openDialog && (type === 'trade' || type === 'modify')
    const bodyMountedRef = useRef(false)
    if (isVisible) {
        bodyMountedRef.current = true
    }
    if (!bodyMountedRef.current) {
        return null
    }
    return <QuickTradeWindowBody isVisible={isVisible} />
}

const QuickTradeWindowBody = ({ isVisible }: QuickTradeWindowBodyProps) => {
    const dispatch = useDispatch()
    const theme = useTheme()
    const navigate = useNavigate()
    const { classes, cx } = useStyles()
    const tradeData = useSelector(selectQuickOrderData) ?? ordersInitialState.quickOrder!
    const {
        openDialog, mode, maxQuantity, tradingAccountId, isSquareOffOrder, type, addStopLoss, addTarget, stopLoss = 0, target = 0, stopLossType, targetType, order = {}, icebergLegs,
    } = tradeData;
    const container = useSelector(selectMultiPaneFullScreen)
    const user = useSelector(selectUserDetails)
    const isUserAdmin = useMemo(()=>{
        return isAdmin(user.currentUser)
    },[user.currentUser])
    const { hasActiveTradingAccount } = useTradingAccountContext()
    const [openAccountDialog, setOpenAccountDialog] = useState(false)

    const { security, transactionType, brokerOrderType, orderId,
        orderType, product, price, triggerPrice, quantity, validity = Validity.DAY, disclosedQuantity = 0, marketProtection = 0 } = order;
    const orderHistory = useSelector(selectOrdersHistory);
    const positions = useSelector(selectPositions)
    const refSecurityMap = useSelector(selectReferenceSecurityMap)
    const [enrichedSecurity, setEnrichedSecurity] = useState<Security | undefined>()
    const [availableExchanges, setAvailableExchanges] = useState<Exchange[]>([])
    const selectedSecurity = useMemo(
        () => enrichedSecurity ?? resolveQuickTradeSecurity(security, refSecurityMap),
        [enrichedSecurity, security, refSecurityMap]
    )
    const orderSecurityKey = useMemo(
        () => (security?.exchange && security?.code ? getSecurityKey(security.exchange, security.code) : ''),
        [security?.exchange, security?.code]
    )
    const lastResolvedSecurityKeyRef = useRef('')
    useEffect(() => {
        if (!orderSecurityKey) {
            lastResolvedSecurityKeyRef.current = ''
            setEnrichedSecurity(undefined)
            setAvailableExchanges([])
            return
        }
        if (lastResolvedSecurityKeyRef.current !== orderSecurityKey) {
            lastResolvedSecurityKeyRef.current = orderSecurityKey
            setAvailableExchanges([])
        }

        let cancelled = false
        getSecurityAsync(orderSecurityKey).then(async (sec) => {
            if (cancelled) return
            if (!sec) {
                setEnrichedSecurity(undefined)
                setAvailableExchanges([])
                return
            }
            if (sec.derived) {
                const refKey = refSecurityMap[orderSecurityKey]
                const refSec = await getSecurityAsync(refKey)
                if (!cancelled) setEnrichedSecurity(refSec ?? sec)
            } else {
                setEnrichedSecurity(sec)
            }
        })
        return () => {
            cancelled = true
        }
    }, [orderSecurityKey, refSecurityMap])
    useEffect(() => {
        if (!isVisible || !selectedSecurity?.code || availableExchanges.length > 0) return
        Promise.all([Exchange.NSE, Exchange.BSE].map(e => getSecurityAsync(getSecurityKey(e, selectedSecurity.code)).then(sec => sec ? e : null))).then(([nse, bse]) => {
            setAvailableExchanges([nse, bse].filter((e): e is Exchange => e != null))
        })
    }, [isVisible, selectedSecurity?.code, availableExchanges.length])

    /** F&O basket CE/CX: underlying/index ref for underlying vs spread chart (matches Trade Panel `conditionalRefSecurity`). */
    const [conditionalChartRefSecurity, setConditionalChartRefSecurity] = useState<
        Awaited<ReturnType<typeof getSecurityAsync>> | undefined
    >()
    useEffect(() => {
        if (!isVisible || !selectedSecurity?.code) {
            if (!isVisible) return
            setConditionalChartRefSecurity(undefined)
            return
        }
        let cancelled = false
        ;(async () => {
            const base = await getSecurityAsync(getSecurityKey(selectedSecurity.exchange, selectedSecurity.code))
            if (cancelled) return
            if (!base) {
                setConditionalChartRefSecurity(undefined)
                return
            }
            if (base.underlyingSecurityCode) {
                const und = await getSecurityAsync(getSecurityKey(base.exchange, base.underlyingSecurityCode))
                if (!cancelled) setConditionalChartRefSecurity(und ?? base)
            } else if (!cancelled) {
                setConditionalChartRefSecurity(base)
            }
        })()
        return () => {
            cancelled = true
        }
    }, [isVisible, selectedSecurity?.exchange, selectedSecurity?.code])

    const selectedSecurityKey = useMemo(() => getSecurityKey(selectedSecurity?.exchange, selectedSecurity?.code), [selectedSecurity])
    const margins = useSelector(selectMargins)
    const tradingAccounts = useSelector(selectTradingAccounts)
    const selectedTradingAccount = useSelector(selectPrimaryTradingAccount)
    const primaryTradingAccount = useMemo(() => {
        if (type === 'modify' || isSquareOffOrder) {
            return tradingAccounts.find(t => t.accountId === tradingAccountId) ?? selectedTradingAccount
        }
        return selectedTradingAccount
    }, [selectedTradingAccount, tradingAccountId, tradingAccounts])
    const [anchorEl, setAnchorEl] = useState<{
        element: HTMLElement
        type: 'price' | 'triggerPrice'
    } | null>(null);
    /** Tracks last quick-trade snapshot/ws subscribe set (security + exchange list). */
    const quickTradeSubscribeRef = useRef('')
    const [isDragging, setIsDragging] = useState(false)
    const basketIdWithExchange = useMemo(() => {
        if (!selectedSecurity || !primaryTradingAccount) return null;
        return `default_${primaryTradingAccount.accountId}_${productToJSON(product)}_${selectedSecurity.code}_${exchangeToJSON(selectedSecurity.exchange)}`.toLowerCase();
    }, [primaryTradingAccount, selectedSecurity, product]);
    const basketIdWithoutExchange = useMemo(() => {
        if (!selectedSecurity || !primaryTradingAccount) return null;
        return `default_${primaryTradingAccount.accountId}_${productToJSON(product)}_${selectedSecurity.code}`.toLowerCase();
    }, [primaryTradingAccount, selectedSecurity, product]);
    const [clientOrderId, setClientOrderId] = useState(uuid());
    const [slClientOrderId, setSlClientOrderId] = useState(uuid());
    const [targetClientOrderId, setTargetClientOrderId] = useState(uuid());
    const [conditionalExitClientOrderId, setConditionalExitClientOrderId] = useState(uuid());
    const [conditionalEntryClientOrderId, setConditionalEntryClientOrderId] = useState(uuid());
    const [showSurveillanceDialog, setShowSurveillanceDialog] = useState(false);
    const [confirmedFromSurveillance, setConfirmedFromSurveillance] = useState(false)
    const [requestInProgres, setRequestInProgress] = useState(false)
    const [popUpOver, setpopUpOver] = useState(false);
    const anchorRef = useRef(null);
    const [advancedMode, setAdvancedMode] = useState(false)
    const [conditionalEntry, setConditionalEntry] = useState<ConditionalEntryState>({ enabled: false })
    const [conditionalExit, setConditionalExit] = useState<ConditionalEntryState>({ enabled: false })
    const [conditionalModify, setConditionalModify] = useState<ConditionalEntryState>({ enabled: false })
    const renderedFirstTime = useRef(false)
    const modifyingOrder = useMemo(() => orderId && orderHistory?.find(o => o.orderId === orderId), [orderId, orderHistory])
    const effectiveIsBasketContext = Boolean(modifyingOrder?.isBasket ?? order?.isBasket)
    /** Real basket id from the order being edited (not only synthetic default_… ids). */
    const anchorBasketId = modifyingOrder?.basketId ?? order?.basketId

    const effectiveSiblingBatchId = modifyingOrder?.batchId ?? order?.batchId

    const resolvedQuickTradeStrategyGroup = useMemo(() => {
        for (const c of [modifyingOrder?.strategyGroup, order?.strategyGroup]) {
            const t = c?.trim()
            if (t && !isPlaceholderStrategyGroupName(t)) return t
        }
        return resolveBasketBatchStrategyGroupName(
            orderHistory,
            anchorBasketId,
            effectiveSiblingBatchId
        )
    }, [
        modifyingOrder?.strategyGroup,
        order?.strategyGroup,
        orderHistory,
        anchorBasketId,
        effectiveSiblingBatchId,
    ])

    const quickTradeBasketCeCxLabel = useMemo(() => {
        const und =
            selectedSecurity?.underlyingSecurityCode ??
            selectedSecurity?.symbol ??
            selectedSecurity?.code ??
            ''
        return basketConditionalRowLabelFromStrategyGroup(resolvedQuickTradeStrategyGroup, und)
    }, [resolvedQuickTradeStrategyGroup, selectedSecurity])

    const conditionalEntryRuleEditAllowed = useMemo(
        () =>
            type !== 'modify' ||
            quickTradeAllowsConditionalEntryRuleEditing(
                orderHistory,
                modifyingOrder ? modifyingOrder : undefined
            ),
        [type, orderHistory, modifyingOrder]
    )

    const conditionalExitRuleEditAllowed = useMemo(
        () =>
            type !== 'modify' ||
            quickTradeAllowsConditionalExitRuleEditing(
                orderHistory,
                modifyingOrder ? modifyingOrder : undefined
            ),
        [type, orderHistory, modifyingOrder]
    )

    const conditionalRowDisplaySymbol = useCallback(
        (cond: Condition | undefined) => {
            if (effectiveIsBasketContext) {
                return quickTradeBasketCeCxLabel
            }
            const base = selectedSecurity?.symbol ?? selectedSecurity?.code ?? ''
            if (!hasConditionalRuleContent(cond)) return base
            if (!conditionalPrimaryUsesSpreadLhs(cond)) return base
            return `${base} Basket`
        },
        [effectiveIsBasketContext, quickTradeBasketCeCxLabel, selectedSecurity]
    )

    const stopLossInputRef = useRef<HTMLInputElement>(null)
    const targetInputRef = useRef<HTMLInputElement>(null)
    const quantityInputRef = useRef<HTMLInputElement>(null)
    const priceInputRef = useRef<HTMLInputElement>(null)
    const [quantityFocused, setQuantityFocused] = useState(false)
    const [quantityDisplay, setQuantityDisplay] = useState('')
    const [quantityError, setQuantityError] = useState('')
    const [priceFocused, setPriceFocused] = useState(false)
    const [priceDisplay, setPriceDisplay] = useState('')
    const [priceError, setPriceError] = useState('')
    const { user: { hasAccess } } = useUser()

    const requiresLimitPrice = useMemo(
        () => [Broker_OrderType.LIMIT_ORDER, Broker_OrderType.STOPLOSS_ORDER].includes(brokerOrderType),
        [brokerOrderType]
    )
    const priceMultiplier = selectedSecurity?.priceMultiplier ?? 100

    const hasSlTargetFeature = useMemo(
        () => hasAccess(FeatureCategory.TRADING, '', FeatureName.SL_AND_TARGET),
        [hasAccess]
    )

    const primaryTradingAccountMarginAvailable = useMemo(() => {
        return margins[primaryTradingAccount?.accountId]?.marginAvailable
    }, [primaryTradingAccount, margins])
    const [requiredMargin, setRequiredMargin] = useState<MarginFromBrokerResponse>({
        totalMargin: 0,
        brokerCharges: undefined,
        costBreakdown: [],
    })
    const [chargesDrawerOpen, setChargesDrawerOpen] = useState(false)
    const toggleChargesDrawer = useCallback((event: React.MouseEvent) => {
        event.stopPropagation()
        setChargesDrawerOpen((open) => !open)
    }, [])

    const matchBasketId = useCallback((order: Order)=>{
        if(!order.basketId) return false
        return (order.basketId === basketIdWithoutExchange || order.basketId === basketIdWithExchange)
    },[basketIdWithoutExchange, basketIdWithExchange])

    const matchesProtectiveSiblingContext = useCallback((o: Order) => {
        /** SL & TP legs often share the same side (e.g. both SELL vs a BUY entry). When modifying an SL/TP row,
         * `transactionType` is that exit side — excluding matching `transactionType` would hide every protective leg. */
        const oIsSlOrTp =
            o.orderType === OrderType.STOP_LOSS || o.orderType === OrderType.TARGET
        if (!oIsSlOrTp && transactionType === o.transactionType) return false
        const batch = effectiveSiblingBatchId
        if (batch && o.batchId !== batch) return false

        const isNonBasketIcebergContext =
            !effectiveIsBasketContext &&
            (modifyingOrder?.orderType === OrderType.ICEBERG || orderType === OrderType.ICEBERG) &&
            mode === 'iceberg'

        if (isNonBasketIcebergContext) {
            if (!anchorBasketId || o.basketId !== anchorBasketId) return false
            return (
                o.security?.code === selectedSecurity?.code &&
                o.security?.exchange === selectedSecurity?.exchange
            )
        }

        if (effectiveIsBasketContext) {
            if (anchorBasketId) return o.basketId === anchorBasketId
            return matchBasketId(o)
        }

        return (
            matchBasketId(o) &&
            o.security?.code === selectedSecurity?.code &&
            o.security?.exchange === selectedSecurity?.exchange
        )
    }, [
        transactionType,
        effectiveSiblingBatchId,
        effectiveIsBasketContext,
        modifyingOrder?.orderType,
        orderType,
        mode,
        anchorBasketId,
        selectedSecurity?.code,
        selectedSecurity?.exchange,
        matchBasketId,
    ])

    /** SL / target legs must use exit side vs batch entry — not `invert(dialog.transactionType)` when editing an SL/TP row (dialog side is already exit). */
    const bracketExitTransactionType = useMemo(
        () =>
            resolveBracketExitTransactionType({
                orderHistory,
                anchorBasketId,
                batchId: effectiveSiblingBatchId,
                security:
                    selectedSecurity?.code != null && selectedSecurity?.exchange != null
                        ? { code: selectedSecurity.code, exchange: selectedSecurity.exchange }
                        : undefined,
                fallbackTransactionType: transactionType ?? TransactionType.BUY,
            }),
        [
            orderHistory,
            anchorBasketId,
            effectiveSiblingBatchId,
            selectedSecurity?.code,
            selectedSecurity?.exchange,
            transactionType,
        ]
    )

    const basketOpenSlOrder = useMemo(() => {
        return (orderHistory || []).find(o => {
            return matchesProtectiveSiblingContext(o) &&
                [OrderStatus.OPEN, OrderStatus.PENDING, OrderStatus.TRIGGER_PENDING].includes(o.status) && o.orderType === OrderType.STOP_LOSS
        })
    }, [matchesProtectiveSiblingContext, orderHistory])

    const basketInactiveSlOrder = useMemo(() => {
        return (orderHistory || []).find(o => {
            return matchesProtectiveSiblingContext(o) &&
                o.status === OrderStatus.INACTIVE &&
                o.orderType === OrderType.STOP_LOSS
        })
    }, [matchesProtectiveSiblingContext, orderHistory])

    const basketOpenTargetOrder = useMemo(() => {
        return (orderHistory || []).find(o => {
            return matchesProtectiveSiblingContext(o) &&
                [OrderStatus.OPEN, OrderStatus.PENDING, OrderStatus.TRIGGER_PENDING].includes(o.status) && o.orderType === OrderType.TARGET
        })
    }, [matchesProtectiveSiblingContext, orderHistory])

    const basketInactiveTargetOrder = useMemo(() => {
        return (orderHistory || []).find(o => {
            return matchesProtectiveSiblingContext(o) &&
                o.status === OrderStatus.INACTIVE &&
                o.orderType === OrderType.TARGET
        })
    }, [matchesProtectiveSiblingContext, orderHistory])

    const condExitSibling = useMemo(() => {
        const hist = orderHistory ?? []
        const batch = effectiveSiblingBatchId
        const matchesSiblingContext = (o: Order) => {
            if (!batch || o.batchId !== batch) return false
            if (effectiveIsBasketContext) {
                if (anchorBasketId) return o.basketId === anchorBasketId
                return matchBasketId(o)
            }
            return (
                o.security?.code === selectedSecurity?.code &&
                o.security?.exchange === selectedSecurity?.exchange
            )
        }
        let inactive: Order | undefined
        let open: Order | undefined
        for (const o of hist) {
            if (o.orderType !== OrderType.CONDITIONAL_EXIT || !matchesSiblingContext(o)) continue
            if (o.status === OrderStatus.INACTIVE) {
                inactive = o
                continue
            }
            if (
                o.status !== OrderStatus.OPEN &&
                o.status !== OrderStatus.PENDING &&
                o.status !== OrderStatus.TRIGGER_PENDING
            ) {
                continue
            }
                open = o
            }
        return { inactive, open }
    }, [
        orderHistory,
        matchBasketId,
        effectiveSiblingBatchId,
        effectiveIsBasketContext,
        anchorBasketId,
        selectedSecurity?.code,
        selectedSecurity?.exchange,
    ])

    const condEntrySibling = useMemo(() => {
        const hist = orderHistory ?? []
        const batch = effectiveSiblingBatchId
        const matchesSiblingContext = (o: Order) => {
            if (!batch || o.batchId !== batch) return false
            if (effectiveIsBasketContext) {
                if (anchorBasketId) return o.basketId === anchorBasketId
                return matchBasketId(o)
            }
            return (
                o.security?.code === selectedSecurity?.code &&
                o.security?.exchange === selectedSecurity?.exchange
            )
        }
        let inactive: Order | undefined
        let open: Order | undefined
        for (const o of hist) {
            if (o.orderType !== OrderType.CONDITIONAL_ENTRY || !matchesSiblingContext(o)) continue
            if (o.status === OrderStatus.INACTIVE) {
                inactive = o
                continue
            }
            if (
                o.status !== OrderStatus.OPEN &&
                o.status !== OrderStatus.PENDING &&
                o.status !== OrderStatus.TRIGGER_PENDING
            ) {
                continue
            }
            open = o
        }
        return { inactive, open }
    }, [
        orderHistory,
        matchBasketId,
        effectiveSiblingBatchId,
        effectiveIsBasketContext,
        anchorBasketId,
        selectedSecurity?.code,
        selectedSecurity?.exchange,
    ])

    /**
     * For non-basket square-off: the batchId of the executed/partially-filled main leg we're exiting.
     * Used to scope CX sibling lookup to the right batch (avoids matching CE-strategy CX from same security).
     */
    const sqOffEntryBatch = useMemo(() => {
        if (!isSquareOffOrder || type !== 'trade' || mode !== 'regular') return undefined
        if (!selectedSecurity?.code || selectedSecurity?.exchange == null) return undefined
        return (orderHistory ?? []).find(
            (o) =>
                matchBasketId(o) &&
                o.security?.code === selectedSecurity.code &&
                o.security?.exchange === selectedSecurity.exchange &&
                !ORDER_TYPES_STRATEGY_AUXILIARY.includes(o.orderType) &&
                (o.status === OrderStatus.EXECUTED || o.status === OrderStatus.PARTIALLY_FILLED)
        )?.batchId
    }, [isSquareOffOrder, type, mode, selectedSecurity?.code, selectedSecurity?.exchange, orderHistory, matchBasketId])

    /** Existing INACTIVE-or-OPEN CX for the batch we're squaring off. */
    const sqOffCxLeg = useMemo((): Order | undefined => {
        if (!sqOffEntryBatch || !selectedSecurity?.code) return undefined
        const pool = (orderHistory ?? []).filter(
            (o) =>
                matchBasketId(o) &&
                o.orderType === OrderType.CONDITIONAL_EXIT &&
                o.security?.code === selectedSecurity.code &&
                o.security?.exchange === selectedSecurity.exchange &&
                o.batchId === sqOffEntryBatch
        )
        return (
            pool.find((o) => o.status === OrderStatus.INACTIVE) ??
            pool.find((o) =>
                [OrderStatus.OPEN, OrderStatus.PENDING, OrderStatus.TRIGGER_PENDING].includes(
                    o.status ?? OrderStatus.ORDER_STATUS_UNKNOWN
                )
            )
        )
    }, [sqOffEntryBatch, selectedSecurity?.code, selectedSecurity?.exchange, orderHistory, matchBasketId])

    /** Modifying a basket primary leg (NORMAL / TRIGGER / ICEBERG), not CE/CX/SL/TP rows. */
    const isModifyingBasketPrimaryMain = useMemo(() => {
        if (type !== 'modify' || !modifyingOrder?.isBasket) return false
        if (
            modifyingOrder.orderType === OrderType.CONDITIONAL_ENTRY ||
            modifyingOrder.orderType === OrderType.CONDITIONAL_EXIT
        ) {
            return false
        }
        if (ORDER_TYPES_STRATEGY_AUXILIARY.includes(modifyingOrder.orderType)) return false
        return true
    }, [type, modifyingOrder])

    /** Hide entire CE/CX strip for live non-basket main modify (use CE/CX order rows or trade panel for CX). */
    const qtModifyHideLiveMainNonBasket = useMemo(
        () =>
            type === 'modify' &&
            !isModifyingBasketPrimaryMain &&
            quickTradeModifySuppressesConditionalTilesOnRow(modifyingOrder),
        [type, modifyingOrder, isModifyingBasketPrimaryMain]
    )

    /** On live basket main modify: hide CE only; CX stays visible so the exit rule can always be edited. */
    const qtModifyHideCeBasketPrimaryLiveMain = useMemo(
        () =>
            type === 'modify' &&
            isModifyingBasketPrimaryMain &&
            quickTradeModifySuppressesConditionalTilesOnRow(modifyingOrder),
        [type, modifyingOrder, isModifyingBasketPrimaryMain]
    )

    /** Basket primary main or live non-basket main — append new CONDITIONAL_EXIT from main (no sibling yet). */
    const isMainLegModifyForCxAppend = useMemo(() => {
        if (type !== 'modify' || !modifyingOrder) return false
        if (
            modifyingOrder.orderType === OrderType.CONDITIONAL_ENTRY &&
            !modifyingOrder.isBasket &&
            !(condExitSibling.open || condExitSibling.inactive)
        ) {
            return true
        }
        if (ORDER_TYPES_STRATEGY_AUXILIARY.includes(modifyingOrder.orderType)) return false
        if (
            modifyingOrder.orderType === OrderType.CONDITIONAL_ENTRY ||
            modifyingOrder.orderType === OrderType.CONDITIONAL_EXIT
        ) {
            return false
        }
        const cxLeg = condExitSibling.inactive ?? condExitSibling.open
        if (cxLeg?.orderId) return false
        if (modifyingOrder.isBasket) return isModifyingBasketPrimaryMain
        return quickTradeModifySuppressesConditionalTilesOnRow(modifyingOrder)
    }, [
        type,
        modifyingOrder,
        isModifyingBasketPrimaryMain,
        condExitSibling.inactive,
        condExitSibling.open,
    ])

    /** Show “add CX” on main leg only when batch has no open/inactive CX yet (edits use CX row). */
    const showMainLegCxAddStrip = useMemo(
        () => !(condExitSibling.open || condExitSibling.inactive),
        [condExitSibling.open, condExitSibling.inactive]
    )

    /**
     * Modify: show CE / merged conditional UI only if CE was part of place (merged rule on main or CE sibling leg).
     * Do not offer adding a new CE from Quick Trade when modifying an open (or any) main without prior CE.
     */
    const qtModifyShowConditionalEntryAdvanced = useMemo(() => {
        if (type !== 'modify' || !modifyingOrder) return true
        if (modifyingOrder.orderType === OrderType.CONDITIONAL_ENTRY) return true
        if (modifyingOrder.orderType === OrderType.CONDITIONAL_EXIT) return true
        if (ORDER_TYPES_STRATEGY_AUXILIARY.includes(modifyingOrder.orderType)) return false
        if (hasConditionalRuleContent(modifyingOrder.orderExecutionParams?.condition)) return true
        const entrySib = condEntrySibling.inactive ?? condEntrySibling.open
        return !!entrySib?.orderId
    }, [type, modifyingOrder, condEntrySibling.inactive, condEntrySibling.open])

    const basketBatchHasCeOrder = useMemo(() => {
        const m = modifyingOrder
        if (!m?.isBasket || !m.basketId || !m.batchId || !orderHistory?.length) return false
        return orderHistory.some(
            (o) =>
                o.basketId === m.basketId &&
                o.batchId === m.batchId &&
                o.orderType === OrderType.CONDITIONAL_ENTRY &&
                [
                    OrderStatus.OPEN,
                    OrderStatus.PENDING,
                    OrderStatus.TRIGGER_PENDING,
                    OrderStatus.INACTIVE,
                ].includes(o.status ?? OrderStatus.UNRECOGNIZED)
        )
    }, [modifyingOrder, orderHistory])

    /** Basket CE is a separate order — do not merge CE into the main leg from Quick Trade when a CE leg exists. */
    const suppressBasketMainCeInQuickTrade =
        isModifyingBasketPrimaryMain && basketBatchHasCeOrder

    /** True if the order already had a conditional rule (or live CE sibling) before this modify — clear/delete stay locked. */
    const persistedConditionalOnModifyOrder = useMemo(() => {
        if (type !== 'modify' || !modifyingOrder) return false
        if (
            modifyingOrder.orderType === OrderType.CONDITIONAL_ENTRY ||
            modifyingOrder.orderType === OrderType.CONDITIONAL_EXIT
        ) {
            return true
        }
        if (hasConditionalRuleContent(modifyingOrder.orderExecutionParams?.condition)) return true
        const entrySib = condEntrySibling.inactive ?? condEntrySibling.open
        if (hasConditionalRuleContent(entrySib?.orderExecutionParams?.condition)) return true
        return false
    }, [type, modifyingOrder, condEntrySibling.inactive, condEntrySibling.open])

    const modifyConditionalLabelOverride = useMemo(() => {
        if (type !== 'modify' || !modifyingOrder) return 'CONDITIONAL ENTRY'
        if (modifyingOrder.orderType === OrderType.CONDITIONAL_EXIT) return 'CONDITIONAL EXIT'
        if (modifyingOrder.orderType === OrderType.CONDITIONAL_ENTRY) return 'CONDITIONAL ENTRY'
        return 'CONDITIONAL ENTRY'
    }, [type, modifyingOrder])

    const existingStopLoss = useMemo(() => !!basketOpenSlOrder || (!!basketInactiveSlOrder && !!modifyingOrder), [basketOpenSlOrder, basketInactiveSlOrder, modifyingOrder]);
    const existingTarget = useMemo(() => !!basketOpenTargetOrder || (!!basketInactiveTargetOrder && !!modifyingOrder), [basketOpenTargetOrder, basketInactiveTargetOrder, modifyingOrder]);

    /** Basket CE/CX row modify — SL/TP are for primary legs only (order bar / other rows). */
    const isBasketConditionalLegModify = useMemo(
        () =>
            type === 'modify' &&
            Boolean(modifyingOrder?.isBasket) &&
            (modifyingOrder?.orderType === OrderType.CONDITIONAL_ENTRY ||
                modifyingOrder?.orderType === OrderType.CONDITIONAL_EXIT),
        [type, modifyingOrder]
    );

    /** Batch id for spread snapshot: live sibling batch or resolved from history (book-only / older baskets). */
    const qtBasketChartBatchId = useMemo(() => {
        if (!effectiveIsBasketContext || !anchorBasketId) return ''
        return (
            (effectiveSiblingBatchId ?? '').trim() ||
            resolveBatchIdForBasketFromOrders(orderHistory, anchorBasketId) ||
            ''
        )
    }, [effectiveIsBasketContext, anchorBasketId, effectiveSiblingBatchId, orderHistory])

    const quickTradeBasketPositionsForChart = useMemo((): Position[] => {
        if (!anchorBasketId) return []
        return (positions ?? []).filter((p) => p.basketId === anchorBasketId)
    }, [positions, anchorBasketId])

    const quickTradeBasketChartTradeLines = useMemo((): TradeOrder[] => {
        if (!anchorBasketId || !qtBasketChartBatchId || !orderHistory?.length) return []
        return getNonAuxiliaryLegsInBatch(orderHistory, anchorBasketId, qtBasketChartBatchId)
            .filter((o) => o.security?.code && Math.abs(o.quantity ?? 0) !== 0)
            .map((o) => ({
                security: o.security!,
                clientOrderId: o.clientOrderId || o.orderId,
                transactionType: o.transactionType,
                selected: true,
                quantity: Math.abs(o.quantity ?? 0),
            }))
    }, [anchorBasketId, qtBasketChartBatchId, orderHistory])

    const quickTradeBasketSpreadSnapshot = useMemo(
        () =>
            effectiveIsBasketContext && anchorBasketId
                ? buildStrategySpreadConditionalSnapshot(
                      quickTradeBasketChartTradeLines,
                      quickTradeBasketPositionsForChart.length ? quickTradeBasketPositionsForChart : undefined
                  )
                : null,
        [
            effectiveIsBasketContext,
            anchorBasketId,
            quickTradeBasketChartTradeLines,
            quickTradeBasketPositionsForChart,
        ]
    )

    const quickTradeBasketSpreadModalEnabled = useMemo(() => {
        if (!quickTradeBasketSpreadSnapshot || !conditionalChartRefSecurity) return false
        const uKey = getSecurityKey(conditionalChartRefSecurity.exchange, conditionalChartRefSecurity.code)
        const { securities: keys } = getStrategyChartParamsFromTradeOrders(
            quickTradeBasketChartTradeLines,
            quickTradeBasketPositionsForChart.length ? quickTradeBasketPositionsForChart : undefined
        )
        if (keys.length === 0) return false
        return true
    }, [
        quickTradeBasketSpreadSnapshot,
        conditionalChartRefSecurity,
        quickTradeBasketChartTradeLines,
        quickTradeBasketPositionsForChart,
    ])

    const quickTradeBasketConditionalModalVariants = useMemo(
        () =>
            quickTradeBasketSpreadModalEnabled && quickTradeBasketSpreadSnapshot
                ? { spreadSnapshot: quickTradeBasketSpreadSnapshot, initialRef: 'spread' as const }
                : undefined,
        [quickTradeBasketSpreadModalEnabled, quickTradeBasketSpreadSnapshot]
    )

    const quickTradeBasketConditionalSecurity = useMemo(
        () =>
            quickTradeBasketConditionalModalVariants && conditionalChartRefSecurity
                ? conditionalChartRefSecurity
                : selectedSecurity,
        [quickTradeBasketConditionalModalVariants, conditionalChartRefSecurity, selectedSecurity]
    )

    const isNonBasketModifyCx = useMemo(
        () =>
            type === 'modify' &&
            !!modifyingOrder &&
            !modifyingOrder.isBasket &&
            modifyingOrder.orderType === OrderType.CONDITIONAL_EXIT,
        [type, modifyingOrder]
    );

    const isNonBasketModifyCe = useMemo(
        () =>
            type === 'modify' &&
            !!modifyingOrder &&
            !modifyingOrder.isBasket &&
            modifyingOrder.orderType === OrderType.CONDITIONAL_ENTRY,
        [type, modifyingOrder]
    );

    const modifySourceOrder = useMemo(
        () => (type === 'modify' ? (modifyingOrder ?? order) : undefined),
        [type, modifyingOrder, order]
    );

    const isModifyStopLossRow = useMemo(
        () => type === 'modify' && modifySourceOrder?.orderType === OrderType.STOP_LOSS,
        [type, modifySourceOrder]
    );

    const isModifyTargetRow = useMemo(
        () => type === 'modify' && modifySourceOrder?.orderType === OrderType.TARGET,
        [type, modifySourceOrder]
    );

    const isModifyPrimaryMainLeg = useMemo(
        () =>
            type === 'modify' &&
            !!modifySourceOrder &&
            !ORDER_TYPES_STRATEGY_AUXILIARY.includes(modifySourceOrder.orderType),
        [type, modifySourceOrder]
    );

    /**
     * Modifying a basket primary main leg from Quick Trade: SL/TP add or edit is not allowed
     * here. Basket SL/TP is owned by the basket SL/TP row itself (or the order bar /
     * SlTargetDialog). Sending a leg-level SL/TP from this path can collide with the existing
     * basket SL/TP order and trigger backend rejections like "Security cannot be modified in an
     * order".
     */
    const isBasketPrimaryLegModify = useMemo(
        () =>
            type === 'modify' &&
            !!modifyingOrder &&
            modifyingOrder.isBasket === true &&
            !ORDER_TYPES_STRATEGY_AUXILIARY.includes(modifyingOrder.orderType),
        [type, modifyingOrder]
    );

    /** SL/Target stay visible but are not editable for basket CE/CX modify, non-basket CX, or CE once SL/TP legs exist. */
    const disableQuickTradeSlTargetSection = useMemo(
        () =>
            isBasketConditionalLegModify ||
            isNonBasketModifyCx ||
            (isNonBasketModifyCe && (existingStopLoss || existingTarget)) ||
            isBasketPrimaryLegModify,
        [isBasketConditionalLegModify, isNonBasketModifyCx, isNonBasketModifyCe, existingStopLoss, existingTarget, isBasketPrimaryLegModify]
    );

    const allowQuickTradeSlInRequest = useMemo(
        () =>
            !isBasketConditionalLegModify &&
            !isNonBasketModifyCx &&
            !(isNonBasketModifyCe && existingStopLoss) &&
            !isBasketPrimaryLegModify,
        [isBasketConditionalLegModify, isNonBasketModifyCx, isNonBasketModifyCe, existingStopLoss, isBasketPrimaryLegModify]
    );

    const allowQuickTradeTargetInRequest = useMemo(
        () =>
            !isBasketConditionalLegModify &&
            !isNonBasketModifyCx &&
            !(isNonBasketModifyCe && existingTarget) &&
            !isBasketPrimaryLegModify,
        [isBasketConditionalLegModify, isNonBasketModifyCx, isNonBasketModifyCe, existingTarget, isBasketPrimaryLegModify]
    );

    useEffect(() => {
        if (isModifyStopLossRow) {
            dispatch(
                setQuickOrderData({
                    addStopLoss: true,
                    stopLoss: (modifySourceOrder?.triggerPrice ?? 0) / (selectedSecurity?.priceMultiplier ?? 100),
                    stopLossType: 'price',
                })
            )
        } else if (isBasketPrimaryLegModify) {
            dispatch(setQuickOrderData({
                addStopLoss: false,
                stopLossType: 'points',
                stopLoss: ''
            }))
        } else if (isModifyPrimaryMainLeg) {
            dispatch(setQuickOrderData({
                addStopLoss: false,
                stopLossType: 'points',
                stopLoss: ''
            }))
        } else if (!!basketOpenSlOrder) {
            dispatch(setQuickOrderData({
                addStopLoss: true,
                stopLoss: (basketOpenSlOrder?.triggerPrice ?? 0) / (selectedSecurity?.priceMultiplier ?? 100),
                stopLossType: 'price'
            }))
        } else if (basketInactiveSlOrder && modifyingOrder) {
            dispatch(setQuickOrderData({
                addStopLoss: true,
                stopLoss: (basketInactiveSlOrder?.triggerPrice ?? 0) / (selectedSecurity?.priceMultiplier ?? 100),
                stopLossType: 'price'
            }))
        } else {
            dispatch(setQuickOrderData({
                addStopLoss: false,
                stopLossType: 'points',
                stopLoss: ''
            }))
        }
    }, [isModifyStopLossRow, isBasketPrimaryLegModify, isModifyPrimaryMainLeg, modifySourceOrder, modifyingOrder, basketOpenSlOrder, selectedSecurity, basketInactiveSlOrder, dispatch])

    useEffect(() => {
        if (isModifyTargetRow) {
            dispatch(
                setQuickOrderData({
                    addTarget: true,
                    target: (modifySourceOrder?.price ?? 0) / (selectedSecurity?.priceMultiplier ?? 100),
                    targetType: 'price',
                })
            )
        } else if (isBasketPrimaryLegModify) {
            dispatch(setQuickOrderData({
                addTarget: false,
                targetType: 'points',
                target: ''
            }))
        } else if (isModifyPrimaryMainLeg) {
            dispatch(setQuickOrderData({
                addTarget: false,
                targetType: 'points',
                target: ''
            }))
        } else if (!!basketOpenTargetOrder) {
            dispatch(setQuickOrderData({
                addTarget: true,
                target: (basketOpenTargetOrder?.price ?? 0) / (selectedSecurity?.priceMultiplier ?? 100),
                targetType: 'price'
            }))
        } else if (basketInactiveTargetOrder && modifyingOrder) {
            dispatch(setQuickOrderData({
                addTarget: true,
                target: (basketInactiveTargetOrder?.price ?? 0) / (selectedSecurity?.priceMultiplier ?? 100),
                targetType: 'price'
            }))
        } else {
            dispatch(setQuickOrderData({
                addTarget: false,
                targetType: 'points',
                target: ''
            }))
        }
    }, [isModifyTargetRow, isBasketPrimaryLegModify, isModifyPrimaryMainLeg, modifySourceOrder, modifyingOrder, basketOpenTargetOrder, basketInactiveTargetOrder, selectedSecurity, dispatch])

    const conditionalBlocksPlace = useMemo(() => {
        if (qtModifyHideLiveMainNonBasket) {
            if (!showMainLegCxAddStrip) return false
            if (conditionalExit.enabled && !isConditionalEntryReady(conditionalExit)) return true
            if (conditionalExit.enabled && mode !== 'regular') return true
            return false
        }

        const entryState = type === 'modify' ? conditionalModify : conditionalEntry
        const exitState =
            type === 'modify' && isModifyingBasketPrimaryMain
                ? showMainLegCxAddStrip
                    ? conditionalExit
                    : { enabled: false, condition: undefined }
                : type === 'modify' && isNonBasketModifyCe && showMainLegCxAddStrip
                  ? conditionalExit
                : type === 'modify'
                  ? conditionalModify
                  : conditionalExit

        const skipEntryValidation =
            (type === 'modify' &&
                isModifyingBasketPrimaryMain &&
                (qtModifyHideCeBasketPrimaryLiveMain || !qtModifyShowConditionalEntryAdvanced)) ||
            (type === 'modify' &&
                !isModifyingBasketPrimaryMain &&
                !qtModifyHideLiveMainNonBasket &&
                !qtModifyShowConditionalEntryAdvanced)

        if (!skipEntryValidation && entryState.enabled && !isConditionalEntryReady(entryState)) return true
        if (exitState.enabled && !isConditionalEntryReady(exitState)) return true
        if (
            ((!skipEntryValidation && entryState.enabled) || exitState.enabled) &&
            mode !== 'regular'
        )
            return true

        return false
    }, [
        qtModifyHideLiveMainNonBasket,
        showMainLegCxAddStrip,
        qtModifyHideCeBasketPrimaryLiveMain,
        qtModifyShowConditionalEntryAdvanced,
        type,
        isModifyingBasketPrimaryMain,
        isNonBasketModifyCe,
        conditionalModify,
        conditionalEntry,
        conditionalExit,
        mode,
    ])

    const modifyLocksRegularTriggerTabs = useMemo(
        () =>
            type === 'modify' &&
            (order.orderType === OrderType.CONDITIONAL_ENTRY ||
                order.orderType === OrderType.CONDITIONAL_EXIT ||
                (conditionalModify.enabled &&
                    hasConditionalRuleContent(conditionalModify.condition) &&
                    qtModifyShowConditionalEntryAdvanced) ||
                (isModifyingBasketPrimaryMain &&
                    showMainLegCxAddStrip &&
                    conditionalExit.enabled &&
                    hasConditionalRuleContent(conditionalExit.condition)) ||
                (qtModifyHideLiveMainNonBasket &&
                    showMainLegCxAddStrip &&
                    conditionalExit.enabled &&
                    hasConditionalRuleContent(conditionalExit.condition)) ||
                (isNonBasketModifyCe &&
                    showMainLegCxAddStrip &&
                    conditionalExit.enabled &&
                    hasConditionalRuleContent(conditionalExit.condition))),
        [
            type,
            order.orderType,
            conditionalModify.enabled,
            conditionalModify.condition,
            isModifyingBasketPrimaryMain,
            isNonBasketModifyCe,
            qtModifyHideLiveMainNonBasket,
            showMainLegCxAddStrip,
            qtModifyShowConditionalEntryAdvanced,
            conditionalExit.enabled,
            conditionalExit.condition,
        ]
    )

    const isMarginSecurity = useMemo(() => [SecurityCategory_CategoryCode.FUTURES, SecurityCategory_CategoryCode.OPTIONS].includes(selectedSecurity?.categoryCode), [selectedSecurity]);

    const productItems = useMemo(() => {
        const items = [
            {
                key: Product.INTRADAY,
                label: "Intraday",
                disabled: mode === 'slOrTarget' 
            },
            {
                key: isMarginSecurity ? Product.MARGIN : Product.CNC,
                label: isMarginSecurity ? "MARGIN" : "CNC",
                disabled: mode === 'slOrTarget'
            },
            {
                key: Product.MTF,
                label: "MTF",
                disabled: !isMtfEligibleCashSecurity(selectedSecurity) || mode === 'slOrTarget'
            }
        ]

        return items;
    }, [isMarginSecurity, selectedSecurity, mode])
    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setpopUpOver((prev: any) => !prev);
    };

    const handleClose = () => {
        setpopUpOver(false);
    };

    const updateCurrentMarketPrice = useCallback(() => {
        const quote = readQuickTradeQuoteScalars(selectedSecurityKey)
        dispatch(
            setQuickOrderData({
            order: {
                price: quote.snapLtp
            }
            })
        );
    }, [dispatch, selectedSecurityKey]);

       useEffect(() => {
        if (!openDialog) {
            setConditionalEntry({ enabled: false, condition: undefined })
            setConditionalExit({ enabled: false, condition: undefined })
            setConditionalModify({ enabled: false, condition: undefined })
            return
        }
        if (type === 'modify' && orderId) {
            const mo = orderHistory?.find((o) => o.orderId === orderId)
            if (mo?.clientOrderId) {
                setClientOrderId(mo.clientOrderId)
            }
        } else if (type === 'trade') {
            setClientOrderId(uuid())
            setSlClientOrderId(uuid())
            setTargetClientOrderId(uuid())
            setConditionalExitClientOrderId(uuid())
            setConditionalEntryClientOrderId(uuid())
        }
    }, [openDialog, type, orderId, orderHistory])

    useEffect(() => {
        setConditionalEntry({ enabled: false, condition: undefined })
        setConditionalExit({ enabled: false, condition: undefined })
        if (type !== 'modify') {
            setConditionalModify({ enabled: false, condition: undefined })
        }
    }, [selectedSecurityKey, type])

    // Pre-populate existing CX condition when opening square-off window for a non-basket position.
    useEffect(() => {
        if (!openDialog || !isSquareOffOrder) return
        const cond = sqOffCxLeg?.orderExecutionParams?.condition
        if (hasConditionalRuleContent(cond)) {
            setConditionalExit({ enabled: true, condition: cond })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- orderId/openDialog used as stable triggers; full sqOffCxLeg recalc on open would cause race with reset effect
    }, [openDialog, isSquareOffOrder, sqOffCxLeg?.orderId])

    useEffect(() => {
        if (type !== 'modify' || !orderId) return
        const exitSibling = condExitSibling.inactive ?? condExitSibling.open
        const entrySibling = condEntrySibling.inactive ?? condEntrySibling.open

        if (isModifyingBasketPrimaryMain || qtModifyHideLiveMainNonBasket) {
            const entryCond = pickMergedConditionForOrderModifyIgnoringExitSibling({
                orderCondition: order.orderExecutionParams?.condition,
                modifyingOrder: modifyingOrder ? modifyingOrder : undefined,
                entrySibling,
            })
            if (hasConditionalRuleContent(entryCond)) {
                setConditionalModify({ enabled: true, condition: entryCond })
            } else {
                setConditionalModify({ enabled: false, condition: undefined })
            }
            const xc = exitSibling?.orderExecutionParams?.condition
            if (hasConditionalRuleContent(xc)) {
                setConditionalExit({ enabled: true, condition: xc })
            } else {
                setConditionalExit({ enabled: false, condition: undefined })
            }
            return
        }

        if (
            modifyingOrder?.orderType === OrderType.CONDITIONAL_ENTRY &&
            !modifyingOrder.isBasket
        ) {
            const ceCond = modifyingOrder.orderExecutionParams?.condition
            if (hasConditionalRuleContent(ceCond)) {
                setConditionalModify({ enabled: true, condition: ceCond })
            } else {
                setConditionalModify({ enabled: false, condition: undefined })
            }
            const hasCxStrip = !(condExitSibling.open || condExitSibling.inactive)
            if (hasCxStrip) {
                setConditionalExit({ enabled: false, condition: undefined })
            } else {
                const xc = exitSibling?.orderExecutionParams?.condition
                if (hasConditionalRuleContent(xc)) {
                    setConditionalExit({ enabled: true, condition: xc })
                } else {
                    setConditionalExit({ enabled: false, condition: undefined })
                }
            }
            return
        }

        const cond = pickMergedConditionForOrderModify({
            orderCondition: order.orderExecutionParams?.condition,
            modifyingOrder: modifyingOrder ? modifyingOrder : undefined,
            exitSibling,
            entrySibling,
        })
        if (hasConditionalRuleContent(cond)) {
            setConditionalModify({ enabled: true, condition: cond })
        } else {
            setConditionalModify({ enabled: false, condition: undefined })
        }
        setConditionalExit({ enabled: false, condition: undefined })
    }, [
        type,
        orderId,
        openDialog,
        selectedSecurityKey,
        order.orderExecutionParams,
        modifyingOrder?.orderId,
        modifyingOrder?.orderType,
        modifyingOrder?.orderExecutionParams,
        modifyingOrder?.isBasket,
        isModifyingBasketPrimaryMain,
        qtModifyHideLiveMainNonBasket,
        condExitSibling.inactive,
        condExitSibling.open,
        condEntrySibling.inactive,
        condEntrySibling.open,
    ])

    useEffect(() => {
        return () => {
            websocketActions.setWebsocketSubscribeList(dispatch, {
                orderBookSubscriptions: [
                    {
                        tag: 'quickTradeOrderBook',
                        securities: [],
                        topBidAskOnly: false
                    }
                ],
                securitySnapshotSubscriptions: [
                    {
                        tag: 'quickTradeSecuritySnapshot',
                        securities: []
                    }
                ]
            })
        }
    }, [])

    const handleRequiredMarginRefresh = useCallback(async () => {
        if (!primaryTradingAccount || primaryTradingAccount.status == TradingAccountStatus.BROKEN) return
        if (selectedSecurity?.instrument === Instrument[Instrument.IDX]) return
        const quote = readQuickTradeQuoteScalars(selectedSecurityKey)
        try {
            const order: MarginFromBrokerRequest_Order = {
                security: {
                    code: selectedSecurity?.code ?? '',
                    exchange: selectedSecurity?.exchange ?? 0
                },
                transactionType,
                orderType: brokerOrderType,
                position: Math.round(Number(quantity)),
                product,
                price: [Broker_OrderType.MARKET_ORDER, Broker_OrderType.STOPLOSS_MARKET_ORDER].includes(brokerOrderType) ? quote.snapLtp : Math.round(Number(price)),
                variety: Broker_Variety.REGULAR,
                ...([Broker_OrderType.STOPLOSS_MARKET_ORDER, Broker_OrderType.STOPLOSS_ORDER].includes(brokerOrderType)
                    ? { triggerPrice: Math.round(Number(triggerPrice)) }
                    : {}),
                exchange: selectedSecurity?.exchange ?? 0
            }
            const tradingAccount: MarginFromBrokerRequest_TradingAccount = {
                accountId: primaryTradingAccount.accountId,
                brokerId: primaryTradingAccount.brokerCode
            }
            const request: MarginFromBrokerRequest = {
                orders: [order],
                tradingAccount: tradingAccount
            }
            const requiredMargin = await getRequiredMarginFromBroker({ request })
            setRequiredMargin(requiredMargin)
            if (selectedSecurity.segment == Segment.CM && primaryTradingAccount.brokerCode && isPaperBrokerCode(primaryTradingAccount.brokerCode)) {
                if (brokerOrderType == Broker_OrderType.MARKET_ORDER || brokerOrderType == Broker_OrderType.STOPLOSS_MARKET_ORDER) {
                    setRequiredMargin({ totalMargin: (quote.snapLtp * quantity / (selectedSecurity?.priceMultiplier ?? 100)), brokerCharges: requiredMargin.brokerCharges, costBreakdown: requiredMargin.costBreakdown })
                } else {
                    setRequiredMargin({ totalMargin: price * quantity / (selectedSecurity?.priceMultiplier ?? 100), brokerCharges: requiredMargin.brokerCharges, costBreakdown: requiredMargin.costBreakdown })
                }
                return
            }
        } catch (e) {
            console.error('Failed to refresh required margin', e)
        }
    }, [primaryTradingAccount, selectedSecurity, selectedSecurityKey, transactionType, brokerOrderType, quantity, product, price, triggerPrice])

    const debouncedRefresh = useMemo(
        () => debounce(300, handleRequiredMarginRefresh),
        [handleRequiredMarginRefresh]
    )

    useEffect(() => {
        if (!isVisible) return
        debouncedRefresh()
        return () => debouncedRefresh.cancel()
    }, [isVisible, debouncedRefresh])

    const handleAllMarginsRefresh = useCallback(async () => {
        if (!primaryTradingAccount || primaryTradingAccount.status !== TradingAccountStatus.ACTIVE) {
            return
        }
        try {
            const body = {
                accountId: primaryTradingAccount.accountId,
                brokerCode: primaryTradingAccount.brokerCode,
                created: primaryTradingAccount.created
            }
            const response = await getAccountMargins({ body })
            dispatch(setMarginForAccount({ accountId: primaryTradingAccount.accountId, margin: response }))
            await handleRequiredMarginRefresh()
        } catch (e) {
            console.error('Failed to refresh margin', e)
        }
    }, [primaryTradingAccount, dispatch, handleRequiredMarginRefresh]);

    useEffect(() => {
        setClientOrderId(uuid());
        setSlClientOrderId(uuid());
        setTargetClientOrderId(uuid());
    }, [primaryTradingAccount, transactionType])

    useEffect(() => {
        if (!isVisible || !selectedSecurity?.code || availableExchanges.length === 0) return

        const frame = requestAnimationFrame(() => {
        const securityKey = getSecurityKey(selectedSecurity.exchange, selectedSecurity.code)
        const subscribeKey = `${securityKey}\x1e${[...availableExchanges].sort((a, b) => a - b).join(',')}`
        if (subscribeKey === quickTradeSubscribeRef.current) return

        const prevSecurityKey = quickTradeSubscribeRef.current.split('\x1e')[0] ?? ''
        quickTradeSubscribeRef.current = subscribeKey

        if (securityKey !== prevSecurityKey) {
            setClientOrderId(uuid());
            setSlClientOrderId(uuid());
            setTargetClientOrderId(uuid());
        }

        const securitiesToFetch = availableExchanges.map(exchange => ({
            exchange,
            code: selectedSecurity.code
        }));

        (async () => {
            try {
                const response = await fetchSecuritySnapshotsBulk({
                    securities: securitiesToFetch,
                    dispatch
                })
                const snapshot = response.securitySnapshots.find(s =>
                    s.security?.code === selectedSecurity?.code &&
                    s.security?.exchange === selectedSecurity?.exchange
                )
                if (snapshot && type !== 'modify' && renderedFirstTime.current) {
                    dispatch(setQuickOrderData({
                        order: {
                            price: snapshot?.lastTradedPrice ?? 0
                        }
                    }))
                }
                renderedFirstTime.current = true
            } catch (e) {
                console.error('Error fetching snapshot:', e)
            }
        })()

        if (type !== 'modify' && !quantity) {
            dispatch(setQuickOrderData({
                order: {
                    quantity: selectedSecurity?.lotSize || 1
                }
            }))
        }

        websocketActions.setWebsocketSubscribeList(dispatch, {
            securitySnapshotSubscriptions: [
                {
                    tag: 'quickTradeSecuritySnapshot',
                    securities: securitiesToFetch
                }
            ]
        })
        })

        return () => cancelAnimationFrame(frame)
    }, [isVisible, selectedSecurity, availableExchanges, type, quantity, dispatch])

    const onClose = useCallback(() => {
        dispatch(removeQuickOrderData())
    }, [dispatch])

    const onConditionalModifyChange = useCallback((next: ConditionalEntryState) => {
        setConditionalModify(next)
    }, [])

    const isSecurityUnderSurveillance = useMemo(() => {
        return selectedSecurity?.surveillanceIndicator;
    }, [selectedSecurity]);

    const surveillanceInfo = useMemo(() => {
        const code = Number(selectedSecurity?.surveillanceIndicator);
        return {
            symbol: selectedSecurity?.code ?? '',
            warningTitle: "Regulatory Caution",
            cautions: code ? [String(code)] : [],
        };
    }, [selectedSecurity]);

    const onModeChange = useCallback((mode: QuickTradeData['mode']) => {
        const { marketLimit } = readQuickTradePreferences()
        const updates: Partial<QuickTradeData> = { mode };

        if (mode === "trigger") {
            updates.order = {
                orderType: OrderType.TRIGGER,
                brokerOrderType: resolveBrokerOrderTypeForMode('trigger', marketLimit),
                triggerPrice: Math.round(price)
            }
        } else if( mode == "iceberg"){
            updates.order = {
                orderType: OrderType.ICEBERG,
                brokerOrderType: Broker_OrderType.LIMIT_ORDER,
                triggerPrice: 0,
                disclosedQuantity: 0,
                validity: Validity.DAY
            }
            updates.icebergLegs = 1 // Default to 1 legs
        } else {
            updates.order = {
                orderType: OrderType.NORMAL,
                brokerOrderType: resolveBrokerOrderTypeForMode('regular', marketLimit),
                triggerPrice: 0
            }
        }
        dispatch(setQuickOrderData(updates))
        saveQuickTradePreferencesFromOrderState(mode, updates.order!.brokerOrderType!, product)
    }, [price, dispatch, product])

    // Helper function to split quantity into legs for iceberg orders
    const splitQuantityIntoLegs = useCallback((totalQuantity: number, numberOfLegs: number | undefined): number[] => {
        const requestedLegs = Math.max(1, numberOfLegs ?? 1);
        
        // Limit actual legs to available quantity (can't have more legs than quantity)
        const actualLegs = Math.min(requestedLegs, totalQuantity);
        
        const baseQtyPerLeg = Math.floor(totalQuantity / actualLegs); // Floor division
        const remainder = totalQuantity % actualLegs; // Get remainder
        
        const legs: number[] = [];
        
        for (let i = 0; i < actualLegs; i++) {
            // First 'remainder' legs get baseQty + 1, rest get baseQty
            if (i < remainder) {
                legs.push(baseQtyPerLeg + 1);
            } else {
                legs.push(baseQtyPerLeg);
            }
        }
        
        return legs;
    }, [])


    const handlePlaceOrder = useCallback(async () => {
        if (!hasActiveTradingAccount) {
            setOpenAccountDialog(true)
            return
        }
        if (!primaryTradingAccount || !tradingAccounts || tradingAccounts?.length === 0) {
            return
        } else if (primaryTradingAccount.status !== TradingAccountStatus.ACTIVE) {
            return
        }
        else if (!confirmedFromSurveillance && isSecurityUnderSurveillance) {
            setShowSurveillanceDialog(true);
            return;
        }
        else {
            const trimmedQuantity = quantityDisplay.trim()
            const parsedQuantity = trimmedQuantity === '' ? NaN : Number(trimmedQuantity)
            if (trimmedQuantity === '' || isNaN(parsedQuantity) || parsedQuantity <= 0) {
                setQuantityError('Enter quantity')
                quantityInputRef.current?.focus()
                return
            }
            setQuantityError('')

            if (requiresLimitPrice) {
                const trimmedPrice = priceDisplay.trim()
                const parsedPrice = trimmedPrice === '' ? NaN : Number(trimmedPrice)
                if (trimmedPrice === '' || isNaN(parsedPrice) || parsedPrice <= 0) {
                    setPriceError('Enter price')
                    priceInputRef.current?.focus()
                    return
                }
                setPriceError('')
            }

            const quote = readQuickTradeQuoteScalars(selectedSecurityKey)
            const stopLossPrice = computeStopLossDisplayPrice({
                quote,
                transactionType,
                brokerOrderType,
                price,
                priceMultiplier,
                addEnabled: addStopLoss,
                value: stopLoss,
                valueType: stopLossType,
                existingLegPrice: existingStopLoss ? Number(stopLoss) : undefined,
            })
            const targetPrice = computeTargetDisplayPrice({
                quote,
                transactionType,
                brokerOrderType,
                price,
                priceMultiplier,
                addEnabled: addTarget,
                value: target,
                valueType: targetType,
                existingLegPrice: existingTarget ? Number(target) : undefined,
            })

            const qtHideCeCx =
                type === 'modify' && quickTradeModifySuppressesConditionalTilesOnRow(modifyingOrder)

            const planConditionalState =
                qtHideCeCx || (type === 'modify' && suppressBasketMainCeInQuickTrade)
                    ? { enabled: false, condition: undefined }
                    : type === 'modify'
                      ? conditionalModify
                      : isSquareOffOrder
                        ? conditionalExit
                        : conditionalEntry

            const plan = buildQuickTradeConditionalPlacePlan({
                placeType: type,
                isSquareOffOrder,
                mode,
                orderType,
                modifyingOrderType: modifyingOrder?.orderType,
                conditionalState: planConditionalState,
                baseExecutionParams: modifyingOrder?.orderExecutionParams,
            })

            /** Iceberg sends only leg rows (no separate `mainOrder`); all rows in the batch must share this id. */
            const isQuickTradeIcebergBatch = orderType === OrderType.ICEBERG && mode === 'iceberg'
            const icebergAuxBasketId = isQuickTradeIcebergBatch
                ? order?.basketId ??
                  modifyingOrder?.basketId ??
                  (selectedSecurity?.segment == Segment.CM ? basketIdWithoutExchange : basketIdWithExchange) ??
                  undefined
                : undefined

            /**
             * Minted per submission, not per mount: this window is visibility-toggled rather than
             * unmounted on close, so a mount-scoped id would be reused for every placement made in
             * the session and iceberg legs would group with the previous placement's legs.
             */
            const batchId = uuid()

            const auxBasketWire = resolveAuxiliaryLegBasketWire({ anchorOrder: modifyingOrder })

            const effectiveMainOrderId =
                type === 'modify' &&
                modifyingOrder?.orderId &&
                modifyingOrder.status !== OrderStatus.CANCELLED &&
                modifyingOrder.status !== OrderStatus.FAILED &&
                modifyingOrder.status !== OrderStatus.REJECTED
                    ? modifyingOrder.orderId
                    : undefined

            /** New place: fresh id each submit. Modify main row: broker order's existing clientOrderId. */
            const mainClientOrderId =
                type === 'modify' && effectiveMainOrderId && modifyingOrder?.clientOrderId
                    ? modifyingOrder.clientOrderId
                    : uuid()

            const mainOrder: Order = {
                security: {
                    code: selectedSecurity?.code ?? '',
                    exchange: selectedSecurity?.exchange ?? 0
                },
                transactionType,
                orderType: plan.mainOrderType,
                brokerOrderType,
                quantity: quantity,
                isBasket: auxBasketWire.isBasket,
                batchId: modifyingOrder ? modifyingOrder.batchId : batchId,
                ...(auxBasketWire.basketId ? { basketId: auxBasketWire.basketId } : {}),
                ...(auxBasketWire.isBasket && resolvedQuickTradeStrategyGroup
                    ? { strategyGroup: resolvedQuickTradeStrategyGroup }
                    : {}),
                orderDate: Date.now(),
                product,
                price: brokerOrderType === Broker_OrderType.MARKET_ORDER || brokerOrderType === Broker_OrderType.STOPLOSS_MARKET_ORDER ? 0 : Math.round(Number(price)),
                triggerPrice: [OrderType.TRIGGER, OrderType.STOP_LOSS].includes(plan.mainOrderType)
                    ? Math.round(Number(triggerPrice))
                    : 0,
                brokerVariety: Broker_Variety.REGULAR,
                validity,
                clientOrderId: mainClientOrderId,
                disclosedQuantity: disclosedQuantity > 0 ? disclosedQuantity : undefined,
                orderId: effectiveMainOrderId,
                immediateExecutePaperOrder: false,
                ...(plan.mainExecutionParams ? { orderExecutionParams: plan.mainExecutionParams } : {}),
            }
            const requestOrders: Order[] = plan.omitMainOrder || isQuickTradeIcebergBatch ? [] : [mainOrder]
            
            // Check if we're modifying an iceberg order
            const isModifyingIceberg = type === 'modify' && mode === "iceberg" && order.batchId && order.basketId;
            
            // Handle iceberg orders - split into multiple legs
            if (orderType === OrderType.ICEBERG && mode === "iceberg") {
                const basePrice = Math.round(Number(price));
                
                if (isModifyingIceberg) {
                    const existingLegs = (orderHistory || []).filter(o => 
                        o.batchId === order.batchId && 
                        o.basketId === order.basketId &&
                        o.security?.code === selectedSecurity?.code && // Filter by security
                        o.security?.exchange === selectedSecurity?.exchange && // Filter by exchange
                        o.orderExecutionParams?.icebergNumberOfLegs &&
                        o.status !== OrderStatus.EXECUTED &&
                        o.status !== OrderStatus.CANCELLED &&
                        o.status !== OrderStatus.FAILED &&
                        o.status !== OrderStatus.REJECTED
                    ).sort((a, b) => 
                        (a.orderExecutionParams?.icebergLegNumber ?? 0) - 
                        (b.orderExecutionParams?.icebergLegNumber ?? 0)
                    );
                    
                    existingLegs.forEach((existingLeg) => {
                        requestOrders.push({
                            security: {
                                code: selectedSecurity?.code ?? '',
                                exchange: selectedSecurity?.exchange ?? 0
                            },
                            transactionType,
                            orderType: OrderType.ICEBERG,
                            brokerOrderType,
                            quantity: existingLeg.quantity, // Keep original quantity
                            isBasket: false,
                            batchId: order.batchId || batchId,
                            basketId: existingLeg.basketId,
                            orderDate: existingLeg.orderDate,
                            product,
                            price: basePrice, // Update price
                            triggerPrice: 0,
                            brokerVariety: Broker_Variety.REGULAR,
                            validity,
                            clientOrderId: `iceberg-leg-${existingLeg.orderExecutionParams?.icebergLegNumber}-${uuid()}`,
                            disclosedQuantity: undefined,
                            orderId: existingLeg.orderId,
                            immediateExecutePaperOrder: false,
                            orderExecutionParams: existingLeg.orderExecutionParams
                        });
                    });
                } else {
                    // For new orders, split quantity into legs
                    const legQuantities = splitQuantityIntoLegs(quantity, icebergLegs);
                    legQuantities.forEach((legQty, index) => {
                        // Generate a unique clientOrderId with timestamp to avoid duplicates
                        const timestamp = Date.now();
                        const uniqueId = uuid();
                        const clientOrderId = `iceberg-leg-${index+1}-${timestamp}-${uniqueId.substring(0, 8)}`;
                        
                        requestOrders.push({
                            security: {
                                code: selectedSecurity?.code ?? '',
                                exchange: selectedSecurity?.exchange ?? 0
                            },
                            transactionType,
                            orderType: OrderType.ICEBERG,
                            brokerOrderType,
                            quantity: legQty,
                            isBasket: false,
                            batchId: order.batchId || batchId,
                            basketId: icebergAuxBasketId,
                            orderDate: Date.now(),
                            product,
                            price: basePrice,
                            triggerPrice: 0,
                            brokerVariety: Broker_Variety.REGULAR,
                            validity,
                            clientOrderId,
                            disclosedQuantity: undefined,
                            immediateExecutePaperOrder: false,
                            orderExecutionParams: {
                                icebergNumberOfLegs: legQuantities.length,
                                icebergLegNumber: index + 1
                            }
                        });
                    });
                }
            } else if (!plan.omitMainOrder && requestOrders.length === 0) {
                // Non-iceberg fallback (should not duplicate `mainOrder` already in `requestOrders`)
                requestOrders.push({
                    security: {
                        code: selectedSecurity?.code ?? '',
                        exchange: selectedSecurity?.exchange ?? 0
                    },
                    transactionType,
                    orderType,
                    brokerOrderType,
                    quantity: quantity,
                    isBasket: auxBasketWire.isBasket,
                    batchId: modifyingOrder ? modifyingOrder.batchId : batchId,
                    ...(auxBasketWire.basketId ? { basketId: auxBasketWire.basketId } : {}),
                    ...(auxBasketWire.isBasket && resolvedQuickTradeStrategyGroup
                        ? { strategyGroup: resolvedQuickTradeStrategyGroup }
                        : {}),
                    orderDate: Date.now(),
                    product,
                    price: brokerOrderType === Broker_OrderType.MARKET_ORDER || brokerOrderType === Broker_OrderType.STOPLOSS_MARKET_ORDER ? 0 : Math.round(Number(price)),
                    triggerPrice: [OrderType.TRIGGER, OrderType.STOP_LOSS].includes(orderType) ? Math.round(Number(triggerPrice)) : 0,
                    brokerVariety: Broker_Variety.REGULAR,
                    validity,
                    clientOrderId: mainClientOrderId,
                    disclosedQuantity: disclosedQuantity > 0 ? disclosedQuantity : undefined,
                    orderId: effectiveMainOrderId,
                    immediateExecutePaperOrder: false,
                });
            }

            const qtAuxBasketId =
                auxBasketWire.basketId ??
                icebergAuxBasketId ??
                requestOrders.find((o) => o.orderType === OrderType.ICEBERG)?.basketId
            const qtAuxIsBasket = auxBasketWire.isBasket || Boolean(icebergAuxBasketId && isQuickTradeIcebergBatch)
            const resolveQtAuxBatchId = (leg: Order | undefined) =>
                resolveAuxiliaryLegBatchId({
                    orders: orderHistory,
                    basketId: qtAuxBasketId ?? modifyingOrder?.basketId,
                    existingAuxLeg: leg,
                    submissionPrimaryBatchId:
                        requestOrders.length > 0
                            ? requestOrders[0].batchId
                            : modifyingOrder?.batchId ?? order?.batchId ?? batchId,
                })

            /** Basket CE/CX/SL/TP: underlying ref + orderBar wire shape (qty 1, BUY, CNC). */
            const strategyBasketAuxSecurity = (): { code: string; exchange: number } => {
                if (qtAuxIsBasket && conditionalChartRefSecurity?.code) {
                    return {
                        code: conditionalChartRefSecurity.code,
                        exchange: conditionalChartRefSecurity.exchange ?? 0,
                    }
                }
                return {
                    code: selectedSecurity?.code ?? '',
                    exchange: selectedSecurity?.exchange ?? 0,
                }
            }
            const strategyBasketAuxOrderExtras = (): Partial<Order> =>
                qtAuxIsBasket && resolvedQuickTradeStrategyGroup
                    ? { strategyGroup: resolvedQuickTradeStrategyGroup }
                    : {}

            /**
             * Non-basket iceberg + SL/TP backend validation requires sibling rows to carry the
             * same `basketId` as iceberg legs when a grouped aux basket is present.
             */
            const slTargetBasketId = qtAuxBasketId

            /** Bracket SL/TP modify: only `mainOrder` for the row being edited — do not append sibling legs (avoids duplicate orders; edit the other leg from its order row). */
            const omitBracketSiblingAppendsOnSlTargetModify =
                type === 'modify' && mode === 'slOrTarget'

            if (
                addStopLoss &&
                stopLossPrice &&
                allowQuickTradeSlInRequest &&
                !omitBracketSiblingAppendsOnSlTargetModify
            ) {
                requestOrders.push({
                    security: strategyBasketAuxSecurity(),
                    transactionType: qtAuxIsBasket ? TransactionType.BUY : bracketExitTransactionType,
                    quantity: qtAuxIsBasket ? 1 : Number(quantity),
                    ...strategyBasketAuxOrderExtras(),
                    orderType: OrderType.STOP_LOSS,
                    brokerOrderType: Broker_OrderType.STOPLOSS_MARKET_ORDER,
                    isBasket: qtAuxIsBasket,
                    batchId: resolveQtAuxBatchId(undefined),
                    ...(slTargetBasketId ? { basketId: slTargetBasketId } : {}),
                    orderDate: Date.now(),
                    product: resolveConditionalAuxProduct(product),
                    price: 0,
                    triggerPrice: getRoundedPrice(stopLossPrice * (selectedSecurity?.priceMultiplier ?? 100), selectedSecurity?.tickSize ?? 5),
                    brokerVariety: Broker_Variety.REGULAR,
                    validity,
                    clientOrderId: slClientOrderId,
                    orderExecutionParams: {},
                    orderId: undefined,
                    immediateExecutePaperOrder: false,
                    marketProtection: -1
                })
            }

            if (
                addTarget &&
                targetPrice &&
                allowQuickTradeTargetInRequest &&
                !omitBracketSiblingAppendsOnSlTargetModify
            ) {
                requestOrders.push({
                    security: strategyBasketAuxSecurity(),
                    transactionType: qtAuxIsBasket ? TransactionType.BUY : bracketExitTransactionType,
                    quantity: qtAuxIsBasket ? 1 : Number(quantity),
                    ...strategyBasketAuxOrderExtras(),
                    orderType: OrderType.TARGET,
                    brokerOrderType: Broker_OrderType.LIMIT_ORDER,
                    isBasket: qtAuxIsBasket,
                    batchId: resolveQtAuxBatchId(undefined),
                    ...(slTargetBasketId ? { basketId: slTargetBasketId } : {}),
                    orderDate: Date.now(),
                    product: resolveConditionalAuxProduct(product),
                    price: getRoundedPrice(targetPrice * (selectedSecurity?.priceMultiplier ?? 100), selectedSecurity?.tickSize ?? 5),
                    triggerPrice: 0,
                    brokerVariety: Broker_Variety.REGULAR,
                    validity,
                    clientOrderId: targetClientOrderId,
                    orderExecutionParams: {},
                    orderId: undefined,
                    immediateExecutePaperOrder: false
                })
            }

            if (
                plan.appendConditionalExitLeg &&
                hasConditionalRuleContent(plan.entryParams?.condition)
            ) {
                const leg =
                    isSquareOffOrder && type === 'trade'
                        ? sqOffCxLeg
                        : condExitSibling.inactive ?? condExitSibling.open
                const cxWire = resolveAuxiliaryLegWireIds({
                    existingLeg: leg,
                    fallbackClientOrderId: conditionalExitClientOrderId,
                })
                requestOrders.push({
                    security: strategyBasketAuxSecurity(),
                    transactionType: qtAuxIsBasket ? TransactionType.BUY : transactionType,
                    quantity: qtAuxIsBasket ? 1 : Number(quantity),
                    ...strategyBasketAuxOrderExtras(),
                    orderType: OrderType.CONDITIONAL_EXIT,
                    brokerOrderType: Broker_OrderType.MARKET_ORDER,
                    isBasket: qtAuxIsBasket,
                    batchId: resolveQtAuxBatchId(leg),
                    ...(qtAuxBasketId ? { basketId: qtAuxBasketId } : {}),
                    orderDate: Date.now(),
                    product: resolveConditionalAuxProduct(product),
                    price: 0,
                    triggerPrice: 0,
                    brokerVariety: Broker_Variety.REGULAR,
                    validity,
                    clientOrderId: cxWire.clientOrderId,
                    disclosedQuantity: disclosedQuantity > 0 ? disclosedQuantity : undefined,
                    orderId: cxWire.orderId,
                    immediateExecutePaperOrder: false,
                    orderExecutionParams: plan.entryParams,
                })
            }

            if (
                plan.appendConditionalEntryLeg &&
                hasConditionalRuleContent(plan.entryParams?.condition)
            ) {
                const leg = condEntrySibling.inactive ?? condEntrySibling.open
                const ceWire = resolveAuxiliaryLegWireIds({
                    existingLeg: leg,
                    fallbackClientOrderId: conditionalEntryClientOrderId,
                })
                requestOrders.push({
                    security: strategyBasketAuxSecurity(),
                    transactionType: qtAuxIsBasket ? TransactionType.BUY : transactionType,
                    quantity: qtAuxIsBasket ? 1 : Number(quantity),
                    ...strategyBasketAuxOrderExtras(),
                    orderType: OrderType.CONDITIONAL_ENTRY,
                    brokerOrderType: Broker_OrderType.MARKET_ORDER,
                    isBasket: qtAuxIsBasket,
                    batchId: resolveQtAuxBatchId(leg),
                    ...(qtAuxBasketId ? { basketId: qtAuxBasketId } : {}),
                    orderDate: Date.now(),
                    product: resolveConditionalAuxProduct(product),
                    price: 0,
                    triggerPrice: 0,
                    brokerVariety: Broker_Variety.REGULAR,
                    validity,
                    clientOrderId: ceWire.clientOrderId,
                    disclosedQuantity: disclosedQuantity > 0 ? disclosedQuantity : undefined,
                    orderId: ceWire.orderId,
                    immediateExecutePaperOrder: false,
                    orderExecutionParams: plan.entryParams,
                })
            }

            // Non-basket entry trade: plan only merges CE into main / CE leg; CX state is separate and was never appended.
            if (
                type === 'trade' &&
                !isSquareOffOrder &&
                mode === 'regular' &&
                conditionalExit.enabled &&
                isConditionalEntryReady(conditionalExit)
            ) {
                const exitParamsForLeg = orderExecutionParamsForConditionalEntry(undefined, conditionalExit, {
                    stripWhenDisabled: true,
                })
                if (hasConditionalRuleContent(exitParamsForLeg?.condition)) {
                    const cxWire = resolveAuxiliaryLegWireIds({
                        existingLeg: undefined,
                        fallbackClientOrderId: conditionalExitClientOrderId,
                    })
                    requestOrders.push({
                        security: {
                            code: selectedSecurity?.code ?? '',
                            exchange: selectedSecurity?.exchange ?? 0,
                        },
                        transactionType,
                        orderType: OrderType.CONDITIONAL_EXIT,
                        brokerOrderType: Broker_OrderType.MARKET_ORDER,
                        quantity: Number(quantity),
                        isBasket: false,
                        batchId: resolveQtAuxBatchId(undefined),
                        orderDate: Date.now(),
                        product,
                        price: 0,
                        triggerPrice: 0,
                        brokerVariety: Broker_Variety.REGULAR,
                        validity,
                        clientOrderId: cxWire.clientOrderId,
                        disclosedQuantity: disclosedQuantity > 0 ? disclosedQuantity : undefined,
                        immediateExecutePaperOrder: false,
                        orderExecutionParams: exitParamsForLeg,
                    })
                }
            }

            // Main-leg modify: create new CONDITIONAL_EXIT or update existing CX (same batchId / basketId as main).
            if (
                type === 'modify' &&
                !isSquareOffOrder &&
                mode === 'regular' &&
                isMainLegModifyForCxAppend &&
                conditionalExit.enabled &&
                isConditionalEntryReady(conditionalExit)
            ) {
                const cxLeg = condExitSibling.inactive ?? condExitSibling.open
                const exitParamsForLeg = orderExecutionParamsForConditionalEntry(
                    cxLeg?.orderExecutionParams,
                    conditionalExit,
                    { stripWhenDisabled: true }
                )
                if (hasConditionalRuleContent(exitParamsForLeg?.condition)) {
                    const cxWire = resolveAuxiliaryLegWireIds({
                        existingLeg: cxLeg,
                        fallbackClientOrderId: conditionalExitClientOrderId,
                    })
                    requestOrders.push({
                        security: strategyBasketAuxSecurity(),
                        transactionType: qtAuxIsBasket ? TransactionType.BUY : transactionType,
                        quantity: qtAuxIsBasket ? 1 : Number(quantity),
                        ...strategyBasketAuxOrderExtras(),
                        orderType: OrderType.CONDITIONAL_EXIT,
                        brokerOrderType: Broker_OrderType.MARKET_ORDER,
                        isBasket: qtAuxIsBasket,
                        batchId: resolveQtAuxBatchId(cxLeg),
                        ...(qtAuxBasketId ? { basketId: qtAuxBasketId } : {}),
                        orderDate: Date.now(),
                        product: resolveConditionalAuxProduct(product),
                        price: 0,
                        triggerPrice: 0,
                        brokerVariety: Broker_Variety.REGULAR,
                        validity,
                        clientOrderId: cxWire.clientOrderId,
                        disclosedQuantity: disclosedQuantity > 0 ? disclosedQuantity : undefined,
                        orderId: cxWire.orderId,
                        immediateExecutePaperOrder: false,
                        orderExecutionParams: exitParamsForLeg,
                    })
                }
            }

            // Non-basket square-off from positions: user applies conditional exit only — send CONDITIONAL_EXIT, not immediate exit / SL / TP / CE.
            if (
                isSquareOffOrder &&
                type === 'trade' &&
                mode === 'regular' &&
                orderType !== OrderType.ICEBERG &&
                conditionalExit.enabled &&
                isConditionalEntryReady(conditionalExit)
            ) {
                const leg = sqOffCxLeg
                const exitParamsOnly = orderExecutionParamsForConditionalEntry(
                    leg?.orderExecutionParams,
                    conditionalExit,
                    { stripWhenDisabled: true }
                )
                if (hasConditionalRuleContent(exitParamsOnly?.condition)) {
                    const sqOffCxWire = resolveAuxiliaryLegWireIds({
                        existingLeg: leg,
                        fallbackClientOrderId: conditionalExitClientOrderId,
                    })
                    const cxOnlyBatchId = resolveAuxiliaryLegBatchId({
                        orders: orderHistory,
                        basketId: leg?.basketId ?? modifyingOrder?.basketId ?? order?.basketId,
                        existingAuxLeg: leg,
                        standaloneEntryBatchId: sqOffEntryBatch ?? modifyingOrder?.batchId ?? order?.batchId ?? batchId,
                    })
                    requestOrders.length = 0
                    requestOrders.push({
                        security: {
                            code: selectedSecurity?.code ?? '',
                            exchange: selectedSecurity?.exchange ?? 0,
                        },
                        transactionType,
                        orderType: OrderType.CONDITIONAL_EXIT,
                        brokerOrderType: Broker_OrderType.MARKET_ORDER,
                        quantity: Number(quantity),
                        isBasket: false,
                        batchId: cxOnlyBatchId,
                        orderDate: Date.now(),
                        product,
                        price: 0,
                        triggerPrice: 0,
                        brokerVariety: Broker_Variety.REGULAR,
                        validity,
                        clientOrderId: sqOffCxWire.clientOrderId,
                        disclosedQuantity: disclosedQuantity > 0 ? disclosedQuantity : undefined,
                        orderId: sqOffCxWire.orderId,
                        immediateExecutePaperOrder: false,
                        orderExecutionParams: exitParamsOnly,
                    })
                }
            }

            const request: PlaceOrModifyOrdersRequest = {
                tradingAccountId: primaryTradingAccount.accountId ?? '',
                order: requestOrders,
                buyBeforeSell: false
            }
            try {
                setRequestInProgress(true);
                const response = await placeOrModifyOrder(request);
                const updates: Order[] = [];
                let successCount = 0;
                (response.orderResponse || []).forEach((orderResponse, i) => {
                    const { successful, commitOrder, brokerOrderId, orderId, errorMessage, order } = orderResponse;
                    if (!successful) {
                        addOrderAlertMessage({
                            ...request.order[i],
                            status: OrderStatus.FAILED,
                            message: errorMessage || 'Unable to place order'
                        })
                        setClientOrderId(uuid());
                        setSlClientOrderId(uuid());
                        setTargetClientOrderId(uuid());
                        setConditionalExitClientOrderId(uuid());
                        setConditionalEntryClientOrderId(uuid());
                        setBatchId(uuid());
                        if (type !== 'modify') {
                            dispatch(setQuickOrderData({ order: { orderId: undefined } }))
                        }
                    } else {
                        successCount++;
                        if (order) {
                            updates.push(order)
                            addOrderAlertMessage({
                                ...order,
                                message: 'Order placed successfully'
                            })
                        }
                    }
                })
                updates.length && dispatch(updateOrderHistory({ updates }))
                successCount === requestOrders.length && onClose();
                setRequestInProgress(false);
            } catch (error: any) {
                addOrderAlertMessage({
                    ...request.order[0],
                    status: OrderStatus.FAILED,
                    message: error.message || 'Unable to place order'
                })
                if (type !== 'modify') {
                    dispatch(setQuickOrderData({ order: { orderId: undefined } }))
                }
                setRequestInProgress(false);
            }
        }
    }, [primaryTradingAccount, tradingAccounts, dispatch, selectedSecurity, transactionType, bracketExitTransactionType, orderType, quantity, product, price,
        triggerPrice, onClose, clientOrderId, confirmedFromSurveillance, type, orderId, mode, disclosedQuantity, marketProtection,
        addStopLoss, stopLoss, stopLossType, slClientOrderId, addTarget, target, targetType, targetClientOrderId, existingStopLoss, existingTarget, selectedSecurityKey,
        allowQuickTradeSlInRequest, allowQuickTradeTargetInRequest,
        brokerOrderType, condExitSibling, modifyingOrder,
        conditionalEntry, conditionalExit, conditionalModify, conditionalExitClientOrderId, conditionalEntryClientOrderId, condEntrySibling, isSquareOffOrder, icebergLegs, splitQuantityIntoLegs,
        suppressBasketMainCeInQuickTrade, isModifyingBasketPrimaryMain, isMainLegModifyForCxAppend, order,
        sqOffEntryBatch, sqOffCxLeg, quantityDisplay, priceDisplay, requiresLimitPrice,
        conditionalChartRefSecurity, resolvedQuickTradeStrategyGroup, orderHistory, hasActiveTradingAccount,
    ])

    const handleQuantityChange = useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        AnalyticsManager.logEvent('Quantity Changed', { source: 'quick-trade-window' })
        const raw = e.target.value
        setQuantityDisplay(raw)
        if (quantityError) {
            setQuantityError('')
        }
        if (raw === '' || isNaN(Number(raw))) return

        let value = Number(raw)
        if (value >= (selectedSecurity?.volumeFreezeQuantity ?? value)) {
            value = (selectedSecurity?.volumeFreezeQuantity ?? value) - 1
        }

        if (maxQuantity && value >= maxQuantity) value = maxQuantity
        if (value < 0) {
            return
        }
        dispatch(setQuickOrderData({
            order: {
                quantity: value
            }
        }))
    }, [maxQuantity, selectedSecurity, dispatch, quantityError])

    const handleQuantityFocus = useCallback(() => {
        setQuantityFocused(true)
        if (quantityError) {
            setQuantityError('')
        }
    }, [quantityError])

    const handleQuantityBlur = useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setQuantityFocused(false)
        const multiple = Math.max(selectedSecurity?.lotSize ?? 1, 1)
        const value = Number(e.target.value) > 0 ? Number(e.target.value) : multiple
        let roundedValue = Math.round(Math.round(value / multiple) * multiple)
        if (roundedValue >= (selectedSecurity?.volumeFreezeQuantity ?? roundedValue)) {
            roundedValue = (selectedSecurity?.volumeFreezeQuantity ?? roundedValue) - 1
        }
        if (roundedValue <= 0) {
            roundedValue = multiple
        }
        if (maxQuantity && roundedValue >= maxQuantity) roundedValue = maxQuantity
        setQuantityDisplay(String(roundedValue))
        setQuantityError('')
        dispatch(setQuickOrderData({
            order: {
                quantity: roundedValue
            }
        }))
    }, [maxQuantity, selectedSecurity, dispatch])

    const handlePriceChange = useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const raw = e.target.value
        setPriceDisplay(raw)
        if (priceError) {
            setPriceError('')
        }
        if (raw === '' || isNaN(Number(raw))) return

        const value = Number(raw)
        if (value < 0) return;
        dispatch(setQuickOrderData({
            order: {
                price: Math.round(value * priceMultiplier)
            }
        }))
    }, [priceMultiplier, dispatch, priceError])


    const handleTriggerPriceChange = useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,) => {
        const value = Number(e.target.value)
        if (value < 0) return;
        dispatch(setQuickOrderData({
            order: {
                triggerPrice: Math.round(value * (selectedSecurity?.priceMultiplier ?? 100))
            }
        }))
    }, [selectedSecurity])

    const handlePriceBlur = useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setPriceFocused(false)
        const raw = e.target.value.trim()
        if (raw === '' || isNaN(Number(raw)) || Number(raw) <= 0) {
            setPriceDisplay('')
            dispatch(setQuickOrderData({
                order: {
                    price: 0
                }
            }))
            return
        }

        const value = Number(raw)
        const multiple = selectedSecurity?.tickSize ?? 5
        const roundedValue = (Math.round(Number(Math.round(value * 100)) / multiple) * multiple) / 100
        setPriceDisplay(String(roundedValue))
        setPriceError('')
        dispatch(setQuickOrderData({
            order: {
                price: Math.round(roundedValue * priceMultiplier)
            }
        }))
    }, [selectedSecurity, priceMultiplier, dispatch])

    const handlePriceFocus = useCallback((e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setPriceFocused(true)
        if (priceError) {
            setPriceError('')
        }
        setAnchorEl({
            element: e.currentTarget,
            type: 'price'
        })
    }, [priceError])

    const handleTriggerPriceBlur = useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const value = Number(e.target.value) > 0 ? Number(e.target.value) : 1
        const multiple = selectedSecurity?.tickSize ?? 5
        const roundedValue = (Math.round(Number(Math.round(value * 100)) / multiple) * multiple) / 100
        dispatch(setQuickOrderData({
            order: {
                triggerPrice: Math.round(roundedValue * (selectedSecurity?.priceMultiplier ?? 100))
            }
        }))
    }, [selectedSecurity])



    const handleTransactionTypeChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.checked
        dispatch(setQuickOrderData({
            order: {
                transactionType: value ? TransactionType.BUY : TransactionType.SELL
            }
        }))
        AnalyticsManager.logEvent('Transaction Type Changed', {
            source: 'quick-trade-window',
            transactionType: transactionTypeToJSON(value ? TransactionType.BUY : TransactionType.SELL)
        })
    }, [])

    const { containerRef, handleRef, position } = useDraggable<HTMLDivElement, HTMLDivElement>(document.body)

    useLayoutEffect(() => {
        registerQuickTradePaper(containerRef.current)
        return () => registerQuickTradePaper(null)
    })

    useLayoutEffect(() => {
        syncQuickTradePaperVisibility()
    }, [isVisible])

    useLayoutEffect(() => {
        if (!isVisible || (type === 'modify' && mode === 'iceberg')) return
        quantityInputRef.current?.focus()
        quantityInputRef.current?.select()
        setQuantityFocused(true)
    }, [isVisible, orderSecurityKey, type, mode])

    useLayoutEffect(() => {
        if (!isVisible || type === 'modify' || quantityFocused) return
        if (!quantity) {
            dispatch(
                setQuickOrderData({
                    order: {
                        quantity: selectedSecurity?.lotSize || 1,
                    },
                })
            )
        }
    }, [isVisible, orderSecurityKey, quantity, type, selectedSecurity?.lotSize, quantityFocused, dispatch])

    useEffect(() => {
        if (!quantityFocused) {
            setQuantityDisplay(quantity > 0 ? String(quantity) : '')
        }
    }, [quantity, quantityFocused])

    useEffect(() => {
        if (!isVisible) {
            setChargesDrawerOpen(false)
        }
    }, [isVisible])

    useEffect(() => {
        if (!isVisible) {
            setQuantityError('')
            setPriceError('')
        }
    }, [isVisible])

    useEffect(() => {
        if (!priceFocused && requiresLimitPrice) {
            setPriceDisplay(price ? String(price / priceMultiplier) : '')
        }
    }, [price, priceFocused, requiresLimitPrice, priceMultiplier])

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                event.stopPropagation()
                onClose?.()
                return
            }

            if (event.key !== 'Enter' || event.shiftKey || event.metaKey || event.ctrlKey || event.altKey) {
                return
            }

            if (showSurveillanceDialog || popUpOver || anchorEl) {
                return
            }

            const target = event.target as HTMLElement
            if (target.tagName === 'TEXTAREA' || target.tagName === 'BUTTON') {
                return
            }

            if (conditionalBlocksPlace || requestInProgres) {
                return
            }

            event.preventDefault()
            event.stopPropagation()
            handlePlaceOrder()
        }

        if (isVisible) {
            window.addEventListener('keydown', handleKeyDown)
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown)
        }
    }, [
        isVisible,
        onClose,
        handlePlaceOrder,
        showSurveillanceDialog,
        popUpOver,
        anchorEl,
        conditionalBlocksPlace,
        requestInProgres,
    ])

    useEffect(() => {
        if (confirmedFromSurveillance) {
            handlePlaceOrder();
        }
    }, [confirmedFromSurveillance]);

    const disableEditableButtons = useMemo(() => Boolean(isSquareOffOrder || type === 'modify'), [isSquareOffOrder, type])

    const onProductChange = useCallback((value: Product) => {
        dispatch(setQuickOrderData({
            order: {
                product: value
            }
        }))
        saveQuickTradePreferencesFromOrderState(mode, brokerOrderType, value)
    }, [mode, brokerOrderType])

    const onOrderTypeToggle = useCallback((e: any, value: Broker_OrderType) => {
        setAnchorEl(null)
        e.stopPropagation();
        
        // Prevent switching to Market order when in iceberg mode
        if (mode === "iceberg" && value === Broker_OrderType.MARKET_ORDER) {
            return;
        }
        
        let updates: Partial<QuickTradeData> = {
            order: {}
        };

        if ((value === Broker_OrderType.LIMIT_ORDER)) {
            const quote = readQuickTradeQuoteScalars(selectedSecurityKey)
            const px = quoteReferenceFromScalars(transactionType, quote)
            if (px > 0) {
                updates.order.price = px
            }
            if (mode === "trigger") {
                updates.order.brokerOrderType = Broker_OrderType.STOPLOSS_ORDER
            } else {
                updates.order.brokerOrderType = Broker_OrderType.LIMIT_ORDER
            }
        } else {
            setPriceError('')
            if (mode === "trigger") {
                updates.order.brokerOrderType = Broker_OrderType.STOPLOSS_MARKET_ORDER
            } else {
                updates.order.brokerOrderType = Broker_OrderType.MARKET_ORDER
            }
        }
        dispatch(setQuickOrderData(updates))
        saveQuickTradePreferencesFromOrderState(mode, updates.order.brokerOrderType!, product)
    }, [selectedSecurityKey, mode, transactionType, dispatch, product])

    const onValidityChange = useCallback((e: any, value: Validity) => {
        // Prevent selecting IOC in iceberg mode
        if (mode === "iceberg" && value === Validity.IOC) {
            return;
        }
        
        dispatch(setQuickOrderData({
            order: {
                validity: value
            }
        }))
    }, [selectedSecurity, mode])

    const toggleAdvanced = useCallback(() => {
        setAdvancedMode(!advancedMode);
    }, [advancedMode])

    const onDisclosedQuantityChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        // Prevent changes to disclosed quantity in iceberg mode
        if (mode === "iceberg") return;
        
        const value = Number(e.target.value);
        if (value < 0) return;
        dispatch(setQuickOrderData({
            order: {
                disclosedQuantity: value
            }
        }))
    }, [mode])

    const onIcebergLegsChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        // Allow empty string or any number
        dispatch(setQuickOrderData({
            icebergLegs: value === '' ? undefined : Number(value)
        }))
    }, [])

    // Calculate quantity per leg for display
    const qtyPerLegDisplay = useMemo(() => {
        if (mode !== "iceberg" || !quantity) return '';
        const legs = splitQuantityIntoLegs(quantity, icebergLegs);
        return `${legs[0]} qty. per leg`;
    }, [mode, quantity, icebergLegs, splitQuantityIntoLegs])

    const clearStopLoss = useCallback(() => {
        dispatch(setQuickOrderData({ addStopLoss: false, stopLoss: '' }))
    }, [dispatch])

    const onStopLossChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        const value = Number(e.target.value);
        if (e.target.value === '') {
            dispatch(setQuickOrderData({
                stopLoss: '',
                addStopLoss: false,
            }))
            return;
        }

        if (value >= 0) {
            dispatch(setQuickOrderData({
                stopLoss: value,
                addStopLoss: true,
            }))
        }
    }, [dispatch])

    const onStopLossTypeChange = useCallback((e: any, value: string) => {
        stopLossInputRef.current?.focus()
        dispatch(setQuickOrderData({
            stopLossType: value as SlTargetType
        }))
    }, [])

    const clearTarget = useCallback(() => {
        dispatch(setQuickOrderData({ addTarget: false, target: '' }))
    }, [dispatch])

    const onTargetChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        const value = Number(e.target.value);
        if (e.target.value === '') {
            dispatch(setQuickOrderData({
                target: '',
                addTarget: false,
            }))
            return;
        }
        if (value >= 0) {
            dispatch(setQuickOrderData({
                target: value,
                addTarget: true,
            }))
        }
    }, [dispatch])

    const onTargetTypeChange = useCallback((e: any, value: string) => {
        targetInputRef.current?.focus()
        dispatch(setQuickOrderData({
            targetType: value as SlTargetType
        }))
    }, [])


    const stopLossField = useMemo(() => {
        const slDisabled = disableQuickTradeSlTargetSection
        const showSlToggles = !existingStopLoss && !slDisabled
        const showSlClear = addStopLoss
        return <>
            <TextField
                label="Stop loss"
                InputLabelProps={{
                    shrink: true
                }}
                type="number"
                size="small"
                fullWidth
                value={stopLoss}
                disabled={slDisabled}
                autoComplete='false'
                onChange={onStopLossChange}
                inputRef={stopLossInputRef}
                inputProps={{
                    step: (selectedSecurity?.tickSize ?? 100) / (selectedSecurity?.priceMultiplier ?? 100)
                }}
                InputProps={{
                    sx: {
                        '& input[type=number]': {
                            MozAppearance: 'textfield'
                        },
                        paddingRight: 0.5,
                    },
                    endAdornment: showSlToggles ? (
                        <>
                            {showSlClear ? (
                                <IconButton
                                    size="small"
                                    aria-label="Clear stop loss"
                                    disabled={slDisabled}
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        clearStopLoss()
                                    }}
                                    sx={slTargetClearBtnSx}
                                >
                                    <SlTargetClearIcon sx={{ fontSize: 14 }} />
                                </IconButton>
                            ) : null}
                            <ToggleButtonGroup
                                size="small"
                                value={stopLossType}
                                aria-label="text alignment"
                                disabled={slDisabled}
                                sx={{
                                    height: "28px",
                                    '.MuiButtonBase-root': {
                                        borderColor: (theme) => theme.palette.background.default
                                    },
                                }}
                            >
                                <ToggleButton disabled={slDisabled} aria-label="left aligned" selected={stopLossType === "points"} value="points" onClick={onStopLossTypeChange}>
                                    Pts
                                </ToggleButton>
                                <ToggleButton disabled={slDisabled} aria-label="left aligned" selected={stopLossType === "percentage"} value="percentage" onClick={onStopLossTypeChange}>
                                    %
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </>
                    ) : null
                }}
            />
            <QuickTradeSlPriceHint
                securityKey={selectedSecurityKey}
                kind="stopLoss"
                transactionType={transactionType}
                brokerOrderType={brokerOrderType}
                price={price}
                priceMultiplier={selectedSecurity?.priceMultiplier ?? 100}
                addEnabled={!!addStopLoss}
                value={stopLoss}
                valueType={stopLossType}
                existingLegPrice={existingStopLoss ? Number(stopLoss) : undefined}
            />
        </>
    }, [selectedSecurity, selectedSecurityKey, transactionType, brokerOrderType, price, addStopLoss, stopLoss, onStopLossChange, stopLossType, onStopLossTypeChange, existingStopLoss, disableQuickTradeSlTargetSection, clearStopLoss])

    const onPriceInputClick = useCallback((e: any) => {
        // Don't auto-switch to limit in iceberg mode (market should not be accessible)
        if (mode === "iceberg") return;
        [Broker_OrderType.STOPLOSS_MARKET_ORDER, Broker_OrderType.MARKET_ORDER].includes(brokerOrderType) && onOrderTypeToggle(e, Broker_OrderType.LIMIT_ORDER)
    }, [brokerOrderType, mode, onOrderTypeToggle])

    const targetField = useMemo(() => {
        const tgDisabled = disableQuickTradeSlTargetSection
        const showTgToggles = !existingTarget && !tgDisabled
        const showTgClear = addTarget
        return <>
            <TextField
                label="Target"
                InputLabelProps={{
                    shrink: true
                }}
                type="number"
                size="small"
                fullWidth
                value={target}
                disabled={tgDisabled}
                autoComplete='false'
                onChange={onTargetChange}
                inputRef={targetInputRef}
                inputProps={{
                    step: (selectedSecurity?.tickSize ?? 100) / (selectedSecurity?.priceMultiplier ?? 100)
                }}
                InputProps={{
                    sx: {
                        '& input[type=number]': {
                            MozAppearance: 'textfield'
                        },
                        paddingRight: 0.5,
                    },
                    endAdornment: showTgToggles ? (
                        <>
                            {showTgClear ? (
                                <IconButton
                                    size="small"
                                    aria-label="Clear target"
                                    disabled={tgDisabled}
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        clearTarget()
                                    }}
                                    sx={slTargetClearBtnSx}
                                >
                                    <SlTargetClearIcon sx={{ fontSize: 14 }} />
                                </IconButton>
                            ) : null}
                            <ToggleButtonGroup
                                size="small"
                                value={targetType}
                                aria-label="text alignment"
                                disabled={tgDisabled}
                                sx={{
                                    height: "28px",
                                    '.MuiButtonBase-root': {
                                        borderColor: (theme) => theme.palette.background.default
                                    },
                                }}
                            >
                                <ToggleButton disabled={tgDisabled} aria-label="left aligned" selected={targetType === "points"} value="points" onClick={onTargetTypeChange}>
                                    Pts
                                </ToggleButton>
                                <ToggleButton disabled={tgDisabled} aria-label="left aligned" selected={targetType === "percentage"} value="percentage" onClick={onTargetTypeChange}>
                                    %
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </>
                    ) : null
                }}
            />
            <QuickTradeSlPriceHint
                securityKey={selectedSecurityKey}
                kind="target"
                transactionType={transactionType}
                brokerOrderType={brokerOrderType}
                price={price}
                priceMultiplier={selectedSecurity?.priceMultiplier ?? 100}
                addEnabled={!!addTarget}
                value={target}
                valueType={targetType}
                existingLegPrice={existingTarget ? Number(target) : undefined}
            />
        </>
    }, [selectedSecurity, selectedSecurityKey, transactionType, brokerOrderType, price, addTarget, target, onTargetChange, targetType, onTargetTypeChange, existingTarget, disableQuickTradeSlTargetSection, clearTarget])

    const handleExchangeChange = useCallback((exchange: Exchange) => {
        dispatch(setQuickOrderData({
            order: {
                security: {
                    exchange,
                    code: order.security?.code
                }
            }
        }))
        AnalyticsManager.logEvent('Exchange Changed', {
            source: 'quick-trade-window',
            exchange: exchange === Exchange.NSE ? 'NSE' : 'BSE'
        })
    }, [order, availableExchanges, dispatch])

    const exchangeSelector =
        selectedSecurity?.code && availableExchanges.length > 1 ? (
            <QuickTradeExchangeSelector
                availableExchanges={availableExchanges}
                selectedSecurity={selectedSecurity}
                type={type}
                onExchangeChange={handleExchangeChange}
            />
        ) : null

    const fullscreenContainer = container ? document.getElementById(MULTIPANE_FULLSCREEN_MODE_ID) : null

    const paperComponent = (
        <>
            <ChargesBreakdownDrawer
                open={chargesDrawerOpen && isVisible}
                instantClose={!isVisible}
                anchorRef={containerRef}
                anchorPositionKey={position}
                items={requiredMargin.costBreakdown}
                total={requiredMargin.brokerCharges ?? 0}
                requiredMargin={requiredMargin.totalMargin}
                availableMargin={primaryTradingAccountMarginAvailable}
                brokerCode={primaryTradingAccount?.brokerCode}
            />
            <Paper
                elevation={3}
                sx={{
                    width: {
                        sm: '90%',
                        lg: 600
                    },
                    overflow: 'hidden',
                    right: position?.right ?? 60,
                    bottom: position?.bottom ?? 5,
                    visibility: 'hidden',
                    pointerEvents: 'none',
                    ...(theme.palette.mode === 'dark'
                        ? {
                              border: '1px solid',
                              borderColor: '#2b2e38',
                              boxSizing: 'border-box',
                          }
                        : {}),
                    ...(fullscreenContainer ? {
                        position: 'fixed',
                        zIndex: 9999
                    } : {})
                }}
                tabIndex={-1}
                className={classes.container}
                ref={containerRef}
            >
                <DialogTitle onPointerDown={() => setIsDragging(true)}
                    onPointerUp={() => setIsDragging(false)}
                    onPointerLeave={() => setIsDragging(false)} className={cx('quick-trade-drage-handle', classes.header)}
                    sx={{
                        cursor: isDragging ? 'grabbing' : 'grab',
                        padding: '10px 15px',
                        userSelect: 'none',
                        backgroundColor: 'background.paper',
                    }}
                    ref={handleRef}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
                        <Stack direction={'row'} alignItems={'center'} spacing={0.5}
                            className={classes.headerText}>
                            {selectedSecurity?.logoUrl ?
                                <Avatar alt={selectedSecurity?.displayName ?? ''}
                                    src={`${LOGOS_BASE_URL}${selectedSecurity?.logoUrl}.svg`}
                                    sx={{ width: 24, height: 24 }} />
                                :
                                <Avatar alt={selectedSecurity?.displayName ?? ''}
                                    sx={{
                                        width: 24,
                                        height: 24,
                                        fontSize: 12,
                                        color: 'white',
                                        bgcolor: getColorForSymbol(selectedSecurity?.symbol || selectedSecurity?.code || '', theme.palette.background.default)
                                    }}>{(selectedSecurity?.symbol || selectedSecurity?.code || '').split(' ').map((word) => word[0]?.toUpperCase()).slice(0, 2).join('')}</Avatar>
                            }
                            <Box sx={{ textWrap: 'nowrap' }}>
                                <Typography component={'span'} fontWeight={'500'}
                                    fontSize={'16px'}>{selectedSecurity?.symbol}</Typography>
                            </Box>
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={1}>
                            {isSecurityUnderSurveillance ? <IconButton onClick={handleOpen} size="small" ref={anchorRef} sx={{
                                backgroundColor: 'rgba(255, 193, 7, 0.1)',
                                borderRadius: 1,
                                transition: 'background-color 0.2s ease',
                                '&:hover': {
                                    backgroundColor: 'rgba(255, 193, 7, 0.2)',
                                },
                                '&:active': {
                                    backgroundColor: 'rgba(255, 193, 7, 0.3)',
                                },
                            }} >
                                <AlertIcon />
                            </IconButton> : null}

                            <PopUpPopover open={popUpOver} onClose={handleClose} info={surveillanceInfo} anchorEl={anchorRef.current} />
                            <FormControlLabel
                                control={
                                    <ToggleSwitch
                                        offColor={red}
                                        onColor={blue}
                                        backgroundOpacity={1}
                                        thumbColor="#fff"
                                        checked={transactionType === TransactionType.BUY}
                                        disabled={disableEditableButtons}
                                        onChange={disableEditableButtons ? undefined : handleTransactionTypeChange}
                                        sx={{ marginLeft: '5px' }}
                                    />}
                                label={transactionType === TransactionType.SELL ? 'Sell' : 'Buy'}
                                labelPlacement="start"
                                style={{ marginRight: '6px', cursor: disableEditableButtons ? 'default' : 'pointer', opacity: disableEditableButtons ? 0.6 : 1 }}
                                className={classes.headerText}
                                disabled={false}
                            />
                        </Stack>
                    </Stack>

                    {exchangeSelector}
                </DialogTitle>
                <Divider />
                {mode !== "slOrTarget" && (
                    <QuickTradeProductTabs
                        disabled={modifyLocksRegularTriggerTabs}
                        disableTriggerIcebergTab={
                            type !== 'modify' &&
                            (conditionalEntry.enabled || conditionalExit.enabled)
                        }
                        onChange={onModeChange}
                    />
                )}
                <DialogContent style={{ padding: '15px' }}>
                    <Grid container rowGap={2} columnSpacing={1}>
                        <Grid container item xs={12} marginBottom={2}>
                            <Grid item xs={6} sx={{ opacity: type === 'modify' ? 0.5 : 1 }}>
                                <GenericFilterTabs items={productItems} value={product} onChange={type === 'modify' ? undefined : onProductChange} disabled={type === 'modify'} />
                            </Grid>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label="Qty"
                                inputRef={quantityInputRef}
                                InputLabelProps={{
                                    shrink: true
                                }}
                                type="number"
                                size="small"
                                fullWidth
                                value={quantityDisplay}
                                error={Boolean(quantityError)}
                                onFocus={handleQuantityFocus}
                                onChange={handleQuantityChange}
                                onBlur={handleQuantityBlur}
                                disabled={type === 'modify' && mode === 'iceberg'}
                                inputProps={{
                                    step: Math.max(selectedSecurity?.lotSize ?? 1, 1)
                                }}
                                helperText={
                                    quantityError ||
                                    (isTradeableSecurity(selectedSecurity)
                                        ? ''
                                        : `Lot size: ${Math.max(selectedSecurity?.lotSize ?? 1, 1)}`)
                                }
                                FormHelperTextProps={{
                                    sx: {
                                        marginTop: '2px',
                                        marginLeft: '2px'
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <OrderBookSelectionDialog
                                anchorEl={anchorEl?.element}
                                security={selectedSecurity}
                                handleOrderBookPriceChange={(price) => {
                                    const event = { target: { value: price.toString() } }
                                    if (anchorEl?.type === 'price') {
                                        handlePriceBlur(event as any)
                                    } else if (anchorEl?.type === 'triggerPrice') {
                                        handleTriggerPriceBlur(event as any)
                                    }
                                    setAnchorEl(null)
                                }}
                            />
                            <ClickAwayListener onClickAway={()=>{
                                if(anchorEl?.type==='price') setAnchorEl(null)
                            }}>
                                <TextField
                                    label={brokerOrderType === Broker_OrderType.MARKET_ORDER ? 'Market price' : 'Price'}
                                    inputRef={priceInputRef}
                                    disabled={brokerOrderType === Broker_OrderType.MARKET_ORDER || brokerOrderType === Broker_OrderType.STOPLOSS_MARKET_ORDER}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    fullWidth
                                    type="number"
                                    size="small"
                                    value={
                                        brokerOrderType === Broker_OrderType.MARKET_ORDER || brokerOrderType === Broker_OrderType.STOPLOSS_MARKET_ORDER
                                            ? 0
                                            : priceDisplay
                                    }
                                    error={Boolean(priceError)}
                                    helperText={priceError || undefined}
                                    onChange={handlePriceChange}
                                    onBlur={handlePriceBlur}
                                    onFocus={handlePriceFocus}
                                    inputProps={{
                                        step: (selectedSecurity?.tickSize ?? 100) / (selectedSecurity?.priceMultiplier ?? 100)
                                    }}
                                    InputProps={{
                                        sx: {
                                            paddingRight: 0.5,
                                            '& input[type=number]': {
                                                MozAppearance: 'textfield'
                                            }
                                        },
                                        endAdornment: (<>
                                            {[Broker_OrderType.STOPLOSS_MARKET_ORDER, Broker_OrderType.MARKET_ORDER].includes(brokerOrderType) && <div className={classes.disabledInputClickBackdrop} onClick={onPriceInputClick} />}
                                            <ToggleButtonGroup
                                                size="small"
                                                value={brokerOrderType}
                                                aria-label="text alignment"
                                                sx={{
                                                    height: "28px",
                                                    '.MuiButtonBase-root': {
                                                        borderColor: (theme) => theme.palette.background.default
                                                    },
                                                    position: 'relative',
                                                    zIndex: 2
                                                }}
                                            >
                                                <ToggleButton aria-label="left aligned" disabled={orderType==OrderType.ICEBERG} selected={[Broker_OrderType.MARKET_ORDER, Broker_OrderType.STOPLOSS_MARKET_ORDER].includes(brokerOrderType)} value={Broker_OrderType.MARKET_ORDER} onClick={onOrderTypeToggle}>
                                                    MKT
                                                </ToggleButton>
                                                <ToggleButton aria-label="left aligned" selected={[Broker_OrderType.LIMIT_ORDER, Broker_OrderType.STOPLOSS_ORDER].includes(brokerOrderType)} value={Broker_OrderType.LIMIT_ORDER} onClick={onOrderTypeToggle}>
                                                    LMT
                                                </ToggleButton>
                                            </ToggleButtonGroup>

                                        </>
                                        )
                                    }}
                                />
                            </ClickAwayListener>
                        </Grid>
                        {(mode === 'trigger' || orderType === OrderType.STOP_LOSS) && <Grid container item xs={12} columnSpacing={1}>
                            <Grid item xs={6}>
                                <ClickAwayListener onClickAway={()=>{
                                    if(anchorEl?.type==='triggerPrice') setAnchorEl(null)
                                }}>
                                    <TextField
                                        label={'Trigger price'}
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        type="number"
                                        size="small"
                                        value={Boolean(triggerPrice) ? triggerPrice / (selectedSecurity?.priceMultiplier ?? 100) : ''}
                                        onChange={handleTriggerPriceChange}
                                        onBlur={handleTriggerPriceBlur}
                                        onFocus={e => {
                                            setAnchorEl({
                                                element: e.currentTarget,
                                                type: 'triggerPrice'
                                            })
                                        }}
                                        inputProps={{
                                            step: (selectedSecurity?.tickSize ?? 100) / (selectedSecurity?.priceMultiplier ?? 100)
                                        }}
                                        InputProps={{
                                            sx: {
                                                '& input[type=number]': {
                                                    MozAppearance: 'textfield'
                                                }
                                            }
                                        }}
                                    />
                                </ClickAwayListener>
                            </Grid>
                        </Grid>}
                        {mode === "iceberg" && (
                            <Grid container item xs={12} columnSpacing={1}>
                                <Grid item xs={6}>
                                    <TextField
                                        label={'Number of legs'}
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        type="number"
                                        size="small"
                                        fullWidth
                                        value={icebergLegs ?? ''}
                                        onChange={onIcebergLegsChange}
                                        disabled={type === 'modify'}
                                        inputProps={{
                                            step: 1
                                        }}
                                        InputProps={{
                                            sx: {
                                                '& input[type=number]': {
                                                    MozAppearance: 'textfield'
                                                }
                                            }
                                        }}
                                        helperText={qtyPerLegDisplay}
                                        FormHelperTextProps={{
                                            sx: {
                                                marginTop: '2px',
                                                marginLeft: '2px'
                                            }
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                </DialogContent>
                {mode !== 'slOrTarget' && <> <Divider />
                    <DialogContent style={{ padding: '15px' }}>
                        {
                            mode !== 'trigger' ? (
                                <Grid container columnSpacing={1} marginBottom={1}>
                                    <Grid item xs={6} paddingLeft={0}>
                                        {stopLossField}
                                    </Grid>
                                    <Grid item xs={6} paddingLeft={0}>
                                        {targetField}
                                    </Grid>
                                </Grid>
                            ) : null
                        }
                        {<Grid container columnSpacing={1} rowGap={1}>
                            <Grid item xs={12} textAlign="center" marginBottom={advancedMode ? 1 : 0}>
                                <span role="button" className={classes.advancedButton} onClick={toggleAdvanced} >Advanced <ThinArrowDownIcon className={advancedMode ? classes.advancedActive : null} /></span>
                            </Grid>

                            {advancedMode && (
                                <Grid container item xs={12} rowGap={2} columnSpacing={1}>
                                    <Grid item xs={6} >
                                        <ToggleButtonGroup
                                            size="small"
                                            value={validity}
                                            aria-label="text alignment"
                                            sx={{
                                                height: "37px",
                                                '.MuiButtonBase-root': {
                                                    borderColor: (theme) => theme.palette.background.default
                                                },
                                            }}
                                        >
                                            <ToggleButton aria-label="left aligned" selected={validity === Validity.DAY} value={Validity.DAY} onClick={onValidityChange}>
                                                DAY
                                            </ToggleButton>
                                            <ToggleButton aria-label="left aligned" disabled={mode === "iceberg"} selected={validity === Validity.IOC} value={Validity.IOC} onClick={onValidityChange}>
                                                IOC
                                            </ToggleButton>
                                            <ToggleButton aria-label="left aligned" selected={validity === Validity.GTT} value={Validity.GTT} onClick={onValidityChange}>
                                                GTT
                                            </ToggleButton>
                                        </ToggleButtonGroup>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            label={'Disclosed Qty'}
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            type="number"
                                            size="small"
                                            fullWidth
                                            value={disclosedQuantity}
                                            disabled={isMarginSecurity || mode === "iceberg"}
                                            onChange={onDisclosedQuantityChange}
                                            inputProps={{
                                                step: selectedSecurity?.lotSize ?? 1
                                            }}
                                            InputProps={{
                                                sx: {
                                                    '& input[type=number]': {
                                                        MozAppearance: 'textfield'
                                                    }
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            label={'Market Protection (%)'}
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            type="number"
                                            size="small"
                                            fullWidth
                                            value={marketProtection}
                                            disabled={[Broker_OrderType.LIMIT_ORDER, Broker_OrderType.STOPLOSS_ORDER].includes(brokerOrderType)}
                                            InputProps={{
                                                sx: {
                                                    '& input[type=number]': {
                                                        MozAppearance: 'textfield'
                                                    }
                                                }
                                            }}
                                        />
                                    </Grid>
                                    {hasSlTargetFeature && selectedSecurity ? (
                                        <Grid item xs={12}>
                                            {type === 'modify' &&
                                            !isSquareOffOrder &&
                                            qtModifyHideLiveMainNonBasket &&
                                            showMainLegCxAddStrip ? (
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <QuickTradeConditionalEntryWithLiveQuote
                                                            variant="exit"
                                                            security={quickTradeBasketConditionalSecurity!}
                                                            conditionalModalChartVariants={
                                                                quickTradeBasketConditionalModalVariants
                                                            }
                                                            displaySymbol={conditionalRowDisplaySymbol(
                                                                conditionalExit.condition
                                                            )}
                                                            liveQuoteSecurityKey={selectedSecurityKey}
                                                            useZeroQuote={!!quickTradeBasketConditionalModalVariants}
                                                            priceMultiplier={
                                                                quickTradeBasketConditionalSecurity?.priceMultiplier ??
                                                                100
                                                            }
                                                            disabled={false}
                                                            allowEnableConditionalEntry={
                                                                mode === 'regular' && conditionalExitRuleEditAllowed
                                                            }
                                                            lockRemoveCondition={false}
                                                            value={conditionalExit}
                                                            onChange={setConditionalExit}
                                                            compact
                                                        />
                                                    </Grid>
                                                </Grid>
                                            ) : type === 'modify' &&
                                            isModifyingBasketPrimaryMain &&
                                            !isSquareOffOrder ? (
                                                <Grid container spacing={2}>
                                                    {!qtModifyHideCeBasketPrimaryLiveMain &&
                                                    qtModifyShowConditionalEntryAdvanced ? (
                                                        <Grid
                                                            item
                                                            xs={showMainLegCxAddStrip ? 6 : 12}
                                                        >
                                                            <QuickTradeConditionalEntryWithLiveQuote
                                                                variant="entry"
                                                                security={quickTradeBasketConditionalSecurity!}
                                                                conditionalModalChartVariants={
                                                                    quickTradeBasketConditionalModalVariants
                                                                }
                                                                displaySymbol={conditionalRowDisplaySymbol(
                                                                    conditionalModify.condition
                                                                )}
                                                                liveQuoteSecurityKey={selectedSecurityKey}
                                                                useZeroQuote={!!quickTradeBasketConditionalModalVariants}
                                                                priceMultiplier={
                                                                    quickTradeBasketConditionalSecurity?.priceMultiplier ??
                                                                    100
                                                                }
                                                                disabled={suppressBasketMainCeInQuickTrade}
                                                                allowEnableConditionalEntry={
                                                                    mode === 'regular' &&
                                                                    conditionalEntryRuleEditAllowed &&
                                                                    !suppressBasketMainCeInQuickTrade
                                                                }
                                                                lockRemoveCondition={
                                                                    !!(condEntrySibling.open || condEntrySibling.inactive)
                                                                }
                                                                value={conditionalModify}
                                                                onChange={setConditionalModify}
                                                                compact
                                                            />
                                                        </Grid>
                                                    ) : null}
                                                    {showMainLegCxAddStrip ? (
                                                        <Grid
                                                            item
                                                            xs={
                                                                qtModifyHideCeBasketPrimaryLiveMain ||
                                                                !qtModifyShowConditionalEntryAdvanced
                                                                    ? 12
                                                                    : 6
                                                            }
                                                        >
                                                            <QuickTradeConditionalEntryWithLiveQuote
                                                                variant="exit"
                                                                security={quickTradeBasketConditionalSecurity!}
                                                                conditionalModalChartVariants={
                                                                    quickTradeBasketConditionalModalVariants
                                                                }
                                                                displaySymbol={conditionalRowDisplaySymbol(
                                                                    conditionalExit.condition
                                                                )}
                                                                liveQuoteSecurityKey={selectedSecurityKey}
                                                                useZeroQuote={!!quickTradeBasketConditionalModalVariants}
                                                                priceMultiplier={
                                                                    quickTradeBasketConditionalSecurity?.priceMultiplier ??
                                                                    100
                                                                }
                                                                disabled={false}
                                                                allowEnableConditionalEntry={
                                                                    mode === 'regular' &&
                                                                    conditionalExitRuleEditAllowed
                                                                }
                                                                lockRemoveCondition={false}
                                                                value={conditionalExit}
                                                                onChange={setConditionalExit}
                                                                compact
                                                            />
                                                        </Grid>
                                                    ) : null}
                                                </Grid>
                                            ) : type === 'modify' &&
                                              !isSquareOffOrder &&
                                              isNonBasketModifyCe &&
                                              qtModifyShowConditionalEntryAdvanced ? (
                                                <Grid container spacing={2}>
                                                    <Grid
                                                        item
                                                        xs={showMainLegCxAddStrip ? 6 : 12}
                                                    >
                                                        <QuickTradeConditionalEntryWithLiveQuote
                                                            variant="modify"
                                                            security={quickTradeBasketConditionalSecurity!}
                                                            conditionalModalChartVariants={
                                                                quickTradeBasketConditionalModalVariants
                                                            }
                                                            displaySymbol={conditionalRowDisplaySymbol(
                                                                conditionalModify.condition
                                                            )}
                                                            liveQuoteSecurityKey={selectedSecurityKey}
                                                            useZeroQuote={!!quickTradeBasketConditionalModalVariants}
                                                            priceMultiplier={
                                                                quickTradeBasketConditionalSecurity?.priceMultiplier ??
                                                                100
                                                            }
                                                            disabled={false}
                                                            allowEnableConditionalEntry={
                                                                mode === 'regular' &&
                                                                conditionalEntryRuleEditAllowed
                                                            }
                                                            persistedOrderHadCondition={
                                                                persistedConditionalOnModifyOrder
                                                            }
                                                            labelOverride={modifyConditionalLabelOverride}
                                                            value={conditionalModify}
                                                            onChange={onConditionalModifyChange}
                                                            compact
                                                        />
                                                    </Grid>
                                                    {showMainLegCxAddStrip ? (
                                                        <Grid item xs={6}>
                                                            <QuickTradeConditionalEntryWithLiveQuote
                                                                variant="exit"
                                                                security={quickTradeBasketConditionalSecurity!}
                                                                conditionalModalChartVariants={
                                                                    quickTradeBasketConditionalModalVariants
                                                                }
                                                                displaySymbol={conditionalRowDisplaySymbol(
                                                                    conditionalExit.condition
                                                                )}
                                                                liveQuoteSecurityKey={selectedSecurityKey}
                                                                useZeroQuote={!!quickTradeBasketConditionalModalVariants}
                                                                priceMultiplier={
                                                                    quickTradeBasketConditionalSecurity?.priceMultiplier ??
                                                                    100
                                                                }
                                                                disabled={false}
                                                                allowEnableConditionalEntry={
                                                                    mode === 'regular' &&
                                                                    conditionalExitRuleEditAllowed
                                                                }
                                                                lockRemoveCondition={false}
                                                                value={conditionalExit}
                                                                onChange={setConditionalExit}
                                                                compact
                                                            />
                                                        </Grid>
                                                    ) : null}
                                                </Grid>
                                            ) : type === 'modify' && qtModifyShowConditionalEntryAdvanced ? (
                                                <QuickTradeConditionalEntryWithLiveQuote
                                                    variant="modify"
                                                    security={quickTradeBasketConditionalSecurity!}
                                                    conditionalModalChartVariants={
                                                        quickTradeBasketConditionalModalVariants
                                                    }
                                                    displaySymbol={conditionalRowDisplaySymbol(
                                                        conditionalModify.condition
                                                    )}
                                                    liveQuoteSecurityKey={selectedSecurityKey}
                                                    useZeroQuote={!!quickTradeBasketConditionalModalVariants}
                                                    priceMultiplier={
                                                        quickTradeBasketConditionalSecurity?.priceMultiplier ?? 100
                                                    }
                                                    disabled={false}
                                                    allowEnableConditionalEntry={
                                                        mode === 'regular' && conditionalEntryRuleEditAllowed
                                                    }
                                                    persistedOrderHadCondition={persistedConditionalOnModifyOrder}
                                                    labelOverride={modifyConditionalLabelOverride}
                                                    value={conditionalModify}
                                                    onChange={onConditionalModifyChange}
                                                    compact
                                                />
                                            ) : type === 'modify' ? null : (
                                                    <Grid container spacing={2}>
                                                        {!isSquareOffOrder && (
                                                        <Grid item xs={6}>
                                                                    <QuickTradeConditionalEntryWithLiveQuote
                                                                        variant="entry"
                                                                        security={quickTradeBasketConditionalSecurity!}
                                                                        conditionalModalChartVariants={
                                                                            quickTradeBasketConditionalModalVariants
                                                                        }
                                                                        displaySymbol={conditionalRowDisplaySymbol(
                                                                            conditionalEntry.condition
                                                                        )}
                                                                        liveQuoteSecurityKey={selectedSecurityKey}
                                                                        useZeroQuote={!!quickTradeBasketConditionalModalVariants}
                                                                        priceMultiplier={
                                                                            quickTradeBasketConditionalSecurity?.priceMultiplier ??
                                                                            100
                                                                        }
                                                                        disabled={false}
                                                                allowEnableConditionalEntry={mode === 'regular' && conditionalEntryRuleEditAllowed}
                                                                        value={conditionalEntry}
                                                                        onChange={setConditionalEntry}
                                                                compact
                                                                    />
                                                            </Grid>
                                                        )}
                                                        {(!isSquareOffOrder ||
                                                            type !== 'trade' ||
                                                            order?.isBasket) && (
                                                        <Grid item xs={isSquareOffOrder ? 12 : 6}>
                                                                <QuickTradeConditionalEntryWithLiveQuote
                                                                    variant="exit"
                                                                    security={quickTradeBasketConditionalSecurity!}
                                                                    conditionalModalChartVariants={
                                                                        quickTradeBasketConditionalModalVariants
                                                                    }
                                                                    displaySymbol={conditionalRowDisplaySymbol(
                                                                        conditionalExit.condition
                                                                    )}
                                                                    liveQuoteSecurityKey={selectedSecurityKey}
                                                                    useZeroQuote={!!quickTradeBasketConditionalModalVariants}
                                                                    priceMultiplier={
                                                                        quickTradeBasketConditionalSecurity?.priceMultiplier ??
                                                                        100
                                                                    }
                                                                    disabled={false}
                                                            allowEnableConditionalEntry={mode === 'regular' && conditionalExitRuleEditAllowed}
                                                                    value={conditionalExit}
                                                                    onChange={setConditionalExit}
                                                            compact
                                                                />
                                                        </Grid>
                                                        )}
                                                    </Grid>
                                            )}
                                        </Grid>
                                    ) : null}
                                </Grid>
                            )}
                        </Grid>}
                    </DialogContent>
                </>}
                <Divider />
                <DialogActions style={{ padding: '10px' }}>
                    <Stack direction={'row'} justifyContent={'space-between'} width={'100%'}>
                        <Stack direction={'row'} gap={2}>
                            {hasActiveTradingAccount && (
                                <>
                                    <TradingAccountSelector disabled={disableEditableButtons} defaultTradingAccountId={tradingAccountId} closeQuickTradeWindow={onClose} />
                                    {(() => {
                                const isAccountActive = primaryTradingAccount?.status === TradingAccountStatus.ACTIVE
                                const hasRequiredMargin = isAccountActive && requiredMargin !== undefined
                                const hasAvailableMargin = isAccountActive && primaryTradingAccountMarginAvailable !== undefined
                                return (
                                    <Stack direction={"row"} gap={2} alignItems={'center'} justifyContent={'center'}>
                                        <Stack
                                            direction={"row"}
                                            gap={1}
                                            sx={{
                                                pr: !isAccountActive ? 3 : 0,
                                                alignItems: 'center',
                                                ...(hasRequiredMargin
                                                    ? { cursor: 'pointer', borderRadius: '4px', '&:hover': { opacity: 0.85 } }
                                                    : {}),
                                            }}
                                            onClick={hasRequiredMargin ? toggleChargesDrawer : undefined}
                                        >
                                            <Typography fontWeight={'medium'} fontSize={12} color="text.secondary">
                                                Required
                                            </Typography>
                                            {hasRequiredMargin ? (
                                                <Typography fontWeight={'medium'} fontSize={12} color={blue}>
                                                    {`₹${requiredMargin.totalMargin.toLocaleString('en-IN')}`}
                                                </Typography>
                                            ) : (
                                                <Typography fontWeight={'medium'} fontSize={12} color="text.secondary">
                                                    —
                                                </Typography>
                                            )}
                                            {hasRequiredMargin && requiredMargin.brokerCharges != null && (
                                                <Typography
                                                    fontWeight={'medium'}
                                                    fontSize={12}
                                                    color="text.secondary"
                                                >
                                                    {`+${requiredMargin.brokerCharges.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                                                </Typography>
                                            )}
                                        </Stack>
                                        <Stack direction={"row"} gap={1} alignItems={'center'}>
                                            <Typography fontWeight={'medium'} fontSize={12} color="text.secondary">
                                                Available
                                            </Typography>
                                            {hasAvailableMargin ? (
                                                <Typography fontWeight={'medium'} fontSize={12} color={blue}>
                                                    {`₹${primaryTradingAccountMarginAvailable.toLocaleString('en-IN')}`}
                                                </Typography>
                                            ) : (
                                                <Typography fontWeight={'medium'} fontSize={12} color="text.secondary">
                                                    —
                                                </Typography>
                                            )}
                                            {isAccountActive && (
                                                <IconButton
                                                    sx={{
                                                        p: 0,
                                                        m: 0,
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                    onClick={handleAllMarginsRefresh}
                                                >
                                                    <RefreshIcon sx={{ width: 16, height: 16, stroke: blue }} />
                                                </IconButton>
                                            )}
                                        </Stack>
                                    </Stack>
                                )
                            })()}
                                </>
                            )}
                        </Stack>
                        <Stack
                            gap={1}
                            direction={{
                                xs: 'row-reverse',
                                sm: 'row'
                            }}
                            sx={{
                                flexShrink: 0,
                                alignSelf: { xs: 'flex-end', sm: 'center' }
                            }}
                        >
                            <Button data-event={'Cancel Clicked'} data-event-source={'quick-trade-window'} size="small"
                                onClick={onClose} variant="outlined">
                                Cancel
                            </Button>
                            <SurveillanceWarningDialog
                                open={showSurveillanceDialog}
                                info={surveillanceInfo}
                                onClose={() => setShowSurveillanceDialog(false)}
                                onConfirm={() => {
                                    setConfirmedFromSurveillance(true);
                                    setShowSurveillanceDialog(false);
                                }}
                            />
                            <LoadingButton
                                data-event={`${transactionType === TransactionType.BUY ? 'Buy' : 'Sell'} Clicked`}
                                data-event-source={'quick-trade-window'} size="small" onClick={handlePlaceOrder}
                                variant="contained"
                                disabled={conditionalBlocksPlace}
                                loading={requestInProgres}>
                                {
                                    hasActiveTradingAccount
                                        ? (transactionType === TransactionType.BUY
                                            ? (!isUserAdmin ? 'Practice Buy' : 'Buy')
                                            : (!isUserAdmin ? 'Practice Sell' : 'Sell'))
                                        : (transactionType === TransactionType.BUY ? 'Buy' : 'Sell')
                                }
                            </LoadingButton>
                        </Stack>
                    </Stack>
                </DialogActions>
            </Paper>
            <OpenTradingAccountDialog
                open={openAccountDialog}
                onClose={() => setOpenAccountDialog(false)}
            />
        </>
    )

    return fullscreenContainer ? ReactDOM.createPortal(paperComponent, fullscreenContainer) : paperComponent
}

export default memo(QuickTradeWindowV2)